var Ua = Object.defineProperty, ka = Object.defineProperties;
var Ba = Object.getOwnPropertyDescriptors;
var _e = Object.getOwnPropertySymbols;
var bn = Object.prototype.hasOwnProperty, wn = Object.prototype.propertyIsEnumerable;
var tr = (r, t, e) => t in r ? Ua(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, b = (r, t) => {
  for (var e in t || (t = {}))
    bn.call(t, e) && tr(r, e, t[e]);
  if (_e)
    for (var e of _e(t))
      wn.call(t, e) && tr(r, e, t[e]);
  return r;
}, P = (r, t) => ka(r, Ba(t));
var On = (r, t) => {
  var e = {};
  for (var n in r)
    bn.call(r, n) && t.indexOf(n) < 0 && (e[n] = r[n]);
  if (r != null && _e)
    for (var n of _e(r))
      t.indexOf(n) < 0 && wn.call(r, n) && (e[n] = r[n]);
  return e;
};
var A = (r, t, e) => tr(r, typeof t != "symbol" ? t + "" : t, e);
var z = (r, t, e) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(e.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(e.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((e = e.apply(r, t)).next());
});
import { W as qi, X as Ha, Y as Br, Z as Ga, A as Wi, s as Bt, _ as ut, $ as Yi, a0 as Ki, a1 as Ji, x as ja, a2 as Va, a3 as Fa, a4 as $a, a5 as Xa, a6 as za, a7 as qa, a8 as Wa, u as Ya, a9 as er, aa as rr, ab as Ka, c as Ja, q as Za, t as Qa, L as ts, M as W, h as Ct, i as es, I as rs, ac as ns, K as An, J as nr, ad as is, ae as os, N as as, O as ss, Q as us, R as cs, T as ls, U as fs, af as ds, ag as ps, ah as Rn, ai as hs, aj as _s, ak as vs } from "./common-D-u0cQmP.js";
import { a as gs, i as Zi } from "./buffer-DIFxvF2Q.js";
import { LDObserve as ms } from "./LDObserve.js";
var Qi = { exports: {} }, ir = { exports: {} }, Ln;
function ys() {
  return Ln || (Ln = 1, function(r, t) {
    (function(e, n) {
      r.exports = n();
    })(qi, function() {
      function e(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(p) {
        if (p)
          for (var g = 0; g < l.length; g++)
            p[l[g]] !== void 0 && this["set" + n(l[g])](p[l[g]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", g = this.getLineNumber() || "", m = this.getColumnNumber() || "", y = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + g + ":" + m + ")" : "[eval]:" + g + ":" + m : y ? y + " (" + p + ":" + g + ":" + m + ")" : p + ":" + g + ":" + m;
        }
      }, f.fromString = function(g) {
        var m = g.indexOf("("), y = g.lastIndexOf(")"), w = g.substring(0, m), L = g.substring(m + 1, y).split(","), B = g.substring(y + 1);
        if (B.indexOf("@") === 0)
          var D = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(B, ""), Nt = D[1], $t = D[2], Mt = D[3];
        return new f({
          functionName: w,
          args: L || void 0,
          fileName: Nt,
          lineNumber: $t || void 0,
          columnNumber: Mt || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = !!g;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + n(a[h])] = i(a[h]), f.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(g) {
            if (!e(g))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(g);
          };
        }(a[h]);
      for (var _ = 0; _ < u.length; _++)
        f.prototype["get" + n(u[_])] = i(u[_]), f.prototype["set" + n(u[_])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = String(g);
          };
        }(u[_]);
      return f;
    });
  }(ir)), ir.exports;
}
(function(r, t) {
  (function(e, n) {
    r.exports = n(ys());
  })(qi, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, g = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: g,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var g = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: g,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Qi);
var Es = Qi.exports;
const Pn = /* @__PURE__ */ Ha(Es);
function Fe(r) {
  try {
    return Pn.parse(r);
  } catch (t) {
    try {
      return Pn.parse(new Error());
    } catch (e) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: e
      }), [];
    }
  }
}
const Kv = {
  level: [...Wi],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function Ts(r, t) {
  const e = t.logger;
  if (!e)
    return () => {
    };
  let n;
  typeof e == "string" ? n = window[e] : n = e;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = Fe(s));
      const f = [
        Br(c, t.stringifyOptions)
      ];
      r({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? Ga(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        r(Ss(u, t, ...s));
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
function Ss(r, t, ...e) {
  const n = Fe(new Error()), i = t.serializeConsoleAttributes ? e.map(
    (o) => typeof o == "object" ? Br(o, t.stringifyOptions) : o
  ) : e.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: r,
    trace: n,
    value: i,
    attributes: Br(
      e.filter((o) => typeof o == "object").reduce((o, a) => b(b({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const bs = {
  start: 0,
  end: 3
}, ws = {
  start: 4,
  end: 5
}, or = {
  start: 6,
  end: 7
}, ar = {
  start: 8,
  end: 8
}, Os = {
  start: 9,
  end: 9
}, As = {
  start: 10,
  end: 15
};
function Rs() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const r = [];
  for (let t = 0; t < 16; t += 1)
    r.push(Math.floor(Math.random() * 256));
  return r;
}
function It(r, t) {
  let e = "";
  for (let n = t.start; n <= t.end; n += 1)
    e += r[n].toString(16).padStart(2, "0");
  return e;
}
function Ls(r) {
  return r[ar.start] = (r[ar.start] | 128) & 191, r[or.start] = r[or.start] & 15 | 64, `${It(r, bs)}-${It(r, ws)}-${It(r, or)}-${It(r, ar)}${It(r, Os)}-${It(r, As)}`;
}
function Ps() {
  const r = Rs();
  return Ls(r);
}
function to() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Ps();
}
function sr(r, t, e, n) {
  var c, s, l, f;
  let i = n != null ? n : t, o = Fe(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = Ms(o);
  r({
    error: i,
    event: Bt(t),
    type: "window.onerror",
    url: window.location.href,
    source: e != null ? e : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (l = u[0]) != null && l.columnNumber ? (f = u[0]) == null ? void 0 : f.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? Bt(a) : void 0,
    id: to()
  });
}
const Ns = (r, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const e = window.onerror = (a, u, c, s, l) => {
    sr(r, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? sr(
        r,
        a.reason,
        a.type,
        u.getStack()
      ) : sr(r, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      A(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = e;
  };
}, Ms = (r) => {
  var e, n;
  if (r.length === 0)
    return r;
  const t = r[0];
  return (e = t.fileName) != null && e.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? r.slice(1) : r;
}, Cs = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Is = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var xs = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, yt = "1.9.0", Nn = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Ds(r) {
  var t = /* @__PURE__ */ new Set([r]), e = /* @__PURE__ */ new Set(), n = r.match(Nn);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === r;
    };
  function o(u) {
    return e.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (e.has(c))
      return !1;
    var s = c.match(Nn);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var Us = Ds(yt), ks = yt.split(".")[0], ne = Symbol.for("opentelemetry.js.api." + ks), ie = xs;
function ce(r, t, e, n) {
  var i;
  n === void 0 && (n = !1);
  var o = ie[ne] = (i = ie[ne]) !== null && i !== void 0 ? i : {
    version: yt
  };
  if (!n && o[r]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + r);
    return e.error(a.stack || a.message), !1;
  }
  if (o.version !== yt) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + r + " does not match previously registered API v" + yt);
    return e.error(a.stack || a.message), !1;
  }
  return o[r] = t, e.debug("@opentelemetry/api: Registered a global for " + r + " v" + yt + "."), !0;
}
function Tt(r) {
  var t, e, n = (t = ie[ne]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !Us(n)))
    return (e = ie[ne]) === null || e === void 0 ? void 0 : e[r];
}
function le(r, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + r + " v" + yt + ".");
  var e = ie[ne];
  e && delete e[r];
}
var Bs = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hs = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, Gs = (
  /** @class */
  function() {
    function r(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return r.prototype.debug = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      return zt("debug", this._namespace, t);
    }, r.prototype.error = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      return zt("error", this._namespace, t);
    }, r.prototype.info = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      return zt("info", this._namespace, t);
    }, r.prototype.warn = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      return zt("warn", this._namespace, t);
    }, r.prototype.verbose = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      return zt("verbose", this._namespace, t);
    }, r;
  }()
);
function zt(r, t, e) {
  var n = Tt("diag");
  if (n)
    return e.unshift(t), n[r].apply(n, Hs([], Bs(e), !1));
}
var R;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.ERROR = 30] = "ERROR", r[r.WARN = 50] = "WARN", r[r.INFO = 60] = "INFO", r[r.DEBUG = 70] = "DEBUG", r[r.VERBOSE = 80] = "VERBOSE", r[r.ALL = 9999] = "ALL";
})(R || (R = {}));
function js(r, t) {
  r < R.NONE ? r = R.NONE : r > R.ALL && (r = R.ALL), t = t || {};
  function e(n, i) {
    var o = t[n];
    return typeof o == "function" && r >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: e("error", R.ERROR),
    warn: e("warn", R.WARN),
    info: e("info", R.INFO),
    debug: e("debug", R.DEBUG),
    verbose: e("verbose", R.VERBOSE)
  };
}
var Vs = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fs = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, $s = "diag", tt = (
  /** @class */
  function() {
    function r() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Tt("diag");
          if (u)
            return u[i].apply(u, Fs([], Vs(o), !1));
        };
      }
      var e = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: R.INFO }), i === e) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return e.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Tt("diag"), f = js((u = o.logLevel) !== null && u !== void 0 ? u : R.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return ce("diag", f, e, !0);
      };
      e.setLogger = n, e.disable = function() {
        le($s, e);
      }, e.createComponentLogger = function(i) {
        return new Gs(i);
      }, e.verbose = t("verbose"), e.debug = t("debug"), e.info = t("info"), e.warn = t("warn"), e.error = t("error");
    }
    return r.instance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r;
  }()
), Xs = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zs = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qs = (
  /** @class */
  function() {
    function r(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return r.prototype.getEntry = function(t) {
      var e = this._entries.get(t);
      if (e)
        return Object.assign({}, e);
    }, r.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var e = Xs(t, 2), n = e[0], i = e[1];
        return [n, i];
      });
    }, r.prototype.setEntry = function(t, e) {
      var n = new r(this._entries);
      return n._entries.set(t, e), n;
    }, r.prototype.removeEntry = function(t) {
      var e = new r(this._entries);
      return e._entries.delete(t), e;
    }, r.prototype.removeEntries = function() {
      for (var t, e, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new r(this._entries);
      try {
        for (var a = zs(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (e = a.return) && e.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, r.prototype.clear = function() {
      return new r();
    }, r;
  }()
), Ws = Symbol("BaggageEntryMetadata"), Ys = tt.instance();
function Ks(r) {
  return r === void 0 && (r = {}), new qs(new Map(Object.entries(r)));
}
function Js(r) {
  return typeof r != "string" && (Ys.error("Cannot create baggage metadata from unknown type: " + typeof r), r = ""), {
    __TYPE__: Ws,
    toString: function() {
      return r;
    }
  };
}
function rn(r) {
  return Symbol.for(r);
}
var Zs = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(t) {
      var e = this;
      e._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), e.getValue = function(n) {
        return e._currentContext.get(n);
      }, e.setValue = function(n, i) {
        var o = new r(e._currentContext);
        return o._currentContext.set(n, i), o;
      }, e.deleteValue = function(n) {
        var i = new r(e._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return r;
  }()
), vt = new Zs(), Ot = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Qs = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.createGauge = function(t, e) {
      return uu;
    }, r.prototype.createHistogram = function(t, e) {
      return cu;
    }, r.prototype.createCounter = function(t, e) {
      return su;
    }, r.prototype.createUpDownCounter = function(t, e) {
      return lu;
    }, r.prototype.createObservableGauge = function(t, e) {
      return du;
    }, r.prototype.createObservableCounter = function(t, e) {
      return fu;
    }, r.prototype.createObservableUpDownCounter = function(t, e) {
      return pu;
    }, r.prototype.addBatchObservableCallback = function(t, e) {
    }, r.prototype.removeBatchObservableCallback = function(t) {
    }, r;
  }()
), $e = (
  /** @class */
  /* @__PURE__ */ function() {
    function r() {
    }
    return r;
  }()
), tu = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.add = function(e, n) {
    }, t;
  }($e)
), eu = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.add = function(e, n) {
    }, t;
  }($e)
), ru = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.record = function(e, n) {
    }, t;
  }($e)
), nu = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.record = function(e, n) {
    }, t;
  }($e)
), nn = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.addCallback = function(t) {
    }, r.prototype.removeCallback = function(t) {
    }, r;
  }()
), iu = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(nn)
), ou = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(nn)
), au = (
  /** @class */
  function(r) {
    Ot(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(nn)
), eo = new Qs(), su = new tu(), uu = new ru(), cu = new nu(), lu = new eu(), fu = new iu(), du = new ou(), pu = new au();
function hu() {
  return eo;
}
var dt;
(function(r) {
  r[r.INT = 0] = "INT", r[r.DOUBLE = 1] = "DOUBLE";
})(dt || (dt = {}));
var _u = {
  get: function(r, t) {
    if (r != null)
      return r[t];
  },
  keys: function(r) {
    return r == null ? [] : Object.keys(r);
  }
}, vu = {
  set: function(r, t, e) {
    r != null && (r[t] = e);
  }
}, gu = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, mu = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, yu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.active = function() {
      return vt;
    }, r.prototype.with = function(t, e, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return e.call.apply(e, mu([n], gu(i), !1));
    }, r.prototype.bind = function(t, e) {
      return e;
    }, r.prototype.enable = function() {
      return this;
    }, r.prototype.disable = function() {
      return this;
    }, r;
  }()
), Eu = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Tu = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, ur = "context", Su = new yu(), Xe = (
  /** @class */
  function() {
    function r() {
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalContextManager = function(t) {
      return ce(ur, t, tt.instance());
    }, r.prototype.active = function() {
      return this._getContextManager().active();
    }, r.prototype.with = function(t, e, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Tu([t, e, n], Eu(o), !1));
    }, r.prototype.bind = function(t, e) {
      return this._getContextManager().bind(t, e);
    }, r.prototype._getContextManager = function() {
      return Tt(ur) || Su;
    }, r.prototype.disable = function() {
      this._getContextManager().disable(), le(ur, tt.instance());
    }, r;
  }()
), ot;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.SAMPLED = 1] = "SAMPLED";
})(ot || (ot = {}));
var ro = "0000000000000000", no = "00000000000000000000000000000000", io = {
  traceId: no,
  spanId: ro,
  traceFlags: ot.NONE
}, Zt = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = io), this._spanContext = t;
    }
    return r.prototype.spanContext = function() {
      return this._spanContext;
    }, r.prototype.setAttribute = function(t, e) {
      return this;
    }, r.prototype.setAttributes = function(t) {
      return this;
    }, r.prototype.addEvent = function(t, e) {
      return this;
    }, r.prototype.addLink = function(t) {
      return this;
    }, r.prototype.addLinks = function(t) {
      return this;
    }, r.prototype.setStatus = function(t) {
      return this;
    }, r.prototype.updateName = function(t) {
      return this;
    }, r.prototype.end = function(t) {
    }, r.prototype.isRecording = function() {
      return !1;
    }, r.prototype.recordException = function(t, e) {
    }, r;
  }()
), on = rn("OpenTelemetry Context Key SPAN");
function an(r) {
  return r.getValue(on) || void 0;
}
function bu() {
  return an(Xe.getInstance().active());
}
function sn(r, t) {
  return r.setValue(on, t);
}
function wu(r) {
  return r.deleteValue(on);
}
function Ou(r, t) {
  return sn(r, new Zt(t));
}
function oo(r) {
  var t;
  return (t = an(r)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Au = /^([0-9a-f]{32})$/i, Ru = /^[0-9a-f]{16}$/i;
function ao(r) {
  return Au.test(r) && r !== no;
}
function Lu(r) {
  return Ru.test(r) && r !== ro;
}
function ze(r) {
  return ao(r.traceId) && Lu(r.spanId);
}
function Pu(r) {
  return new Zt(r);
}
var cr = Xe.getInstance(), so = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.startSpan = function(t, e, n) {
      n === void 0 && (n = cr.active());
      var i = !!(e != null && e.root);
      if (i)
        return new Zt();
      var o = n && oo(n);
      return Nu(o) && ze(o) ? new Zt(o) : new Zt();
    }, r.prototype.startActiveSpan = function(t, e, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = e : arguments.length === 3 ? (o = e, u = n) : (o = e, a = n, u = i);
        var c = a != null ? a : cr.active(), s = this.startSpan(t, o, c), l = sn(c, s);
        return cr.with(l, u, void 0, s);
      }
    }, r;
  }()
);
function Nu(r) {
  return typeof r == "object" && typeof r.spanId == "string" && typeof r.traceId == "string" && typeof r.traceFlags == "number";
}
var Mu = new so(), Cu = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      this._provider = t, this.name = e, this.version = n, this.options = i;
    }
    return r.prototype.startSpan = function(t, e, n) {
      return this._getTracer().startSpan(t, e, n);
    }, r.prototype.startActiveSpan = function(t, e, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, r.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Mu;
    }, r;
  }()
), Iu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getTracer = function(t, e, n) {
      return new so();
    }, r;
  }()
), xu = new Iu(), Mn = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getTracer = function(t, e, n) {
      var i;
      return (i = this.getDelegateTracer(t, e, n)) !== null && i !== void 0 ? i : new Cu(this, t, e, n);
    }, r.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : xu;
    }, r.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, r.prototype.getDelegateTracer = function(t, e, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, e, n);
    }, r;
  }()
), Ce;
(function(r) {
  r[r.NOT_RECORD = 0] = "NOT_RECORD", r[r.RECORD = 1] = "RECORD", r[r.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ce || (Ce = {}));
var oe;
(function(r) {
  r[r.INTERNAL = 0] = "INTERNAL", r[r.SERVER = 1] = "SERVER", r[r.CLIENT = 2] = "CLIENT", r[r.PRODUCER = 3] = "PRODUCER", r[r.CONSUMER = 4] = "CONSUMER";
})(oe || (oe = {}));
var Ie;
(function(r) {
  r[r.UNSET = 0] = "UNSET", r[r.OK = 1] = "OK", r[r.ERROR = 2] = "ERROR";
})(Ie || (Ie = {}));
var S = Xe.getInstance(), v = tt.instance(), Du = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getMeter = function(t, e, n) {
      return eo;
    }, r;
  }()
), Uu = new Du(), lr = "metrics", ku = (
  /** @class */
  function() {
    function r() {
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalMeterProvider = function(t) {
      return ce(lr, t, tt.instance());
    }, r.prototype.getMeterProvider = function() {
      return Tt(lr) || Uu;
    }, r.prototype.getMeter = function(t, e, n) {
      return this.getMeterProvider().getMeter(t, e, n);
    }, r.prototype.disable = function() {
      le(lr, tt.instance());
    }, r;
  }()
), Z = ku.getInstance(), Bu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(t, e) {
    }, r.prototype.extract = function(t, e) {
      return t;
    }, r.prototype.fields = function() {
      return [];
    }, r;
  }()
), un = rn("OpenTelemetry Baggage Key");
function uo(r) {
  return r.getValue(un) || void 0;
}
function Hu() {
  return uo(Xe.getInstance().active());
}
function Gu(r, t) {
  return r.setValue(un, t);
}
function ju(r) {
  return r.deleteValue(un);
}
var fr = "propagation", Vu = new Bu(), Fu = (
  /** @class */
  function() {
    function r() {
      this.createBaggage = Ks, this.getBaggage = uo, this.getActiveBaggage = Hu, this.setBaggage = Gu, this.deleteBaggage = ju;
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalPropagator = function(t) {
      return ce(fr, t, tt.instance());
    }, r.prototype.inject = function(t, e, n) {
      return n === void 0 && (n = vu), this._getGlobalPropagator().inject(t, e, n);
    }, r.prototype.extract = function(t, e, n) {
      return n === void 0 && (n = _u), this._getGlobalPropagator().extract(t, e, n);
    }, r.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, r.prototype.disable = function() {
      le(fr, tt.instance());
    }, r.prototype._getGlobalPropagator = function() {
      return Tt(fr) || Vu;
    }, r;
  }()
), G = Fu.getInstance(), dr = "trace", $u = (
  /** @class */
  function() {
    function r() {
      this._proxyTracerProvider = new Mn(), this.wrapSpanContext = Pu, this.isSpanContextValid = ze, this.deleteSpan = wu, this.getSpan = an, this.getActiveSpan = bu, this.getSpanContext = oo, this.setSpan = sn, this.setSpanContext = Ou;
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalTracerProvider = function(t) {
      var e = ce(dr, this._proxyTracerProvider, tt.instance());
      return e && this._proxyTracerProvider.setDelegate(t), e;
    }, r.prototype.getTracerProvider = function() {
      return Tt(dr) || this._proxyTracerProvider;
    }, r.prototype.getTracer = function(t, e) {
      return this.getTracerProvider().getTracer(t, e);
    }, r.prototype.disable = function() {
      le(dr, tt.instance()), this._proxyTracerProvider = new Mn();
    }, r;
  }()
), O = $u.getInstance(), co = rn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function lo(r) {
  return r.setValue(co, !0);
}
function cn(r) {
  return r.getValue(co) === !0;
}
var Xu = "=", Hr = ";", Gr = ",", pr = "baggage", zu = 180, qu = 4096, Wu = 8192, Yu = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ku(r) {
  return r.reduce(function(t, e) {
    var n = "" + t + (t !== "" ? Gr : "") + e;
    return n.length > Wu ? t : n;
  }, "");
}
function Ju(r) {
  return r.getAllEntries().map(function(t) {
    var e = Yu(t, 2), n = e[0], i = e[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Hr + i.metadata.toString()), o;
  });
}
function Zu(r) {
  var t = r.split(Hr);
  if (!(t.length <= 0)) {
    var e = t.shift();
    if (e) {
      var n = e.indexOf(Xu);
      if (!(n <= 0)) {
        var i = decodeURIComponent(e.substring(0, n).trim()), o = decodeURIComponent(e.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Js(t.join(Hr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var fo = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(t, e, n) {
      var i = G.getBaggage(t);
      if (!(!i || cn(t))) {
        var o = Ju(i).filter(function(u) {
          return u.length <= qu;
        }).slice(0, zu), a = Ku(o);
        a.length > 0 && n.set(e, pr, a);
      }
    }, r.prototype.extract = function(t, e, n) {
      var i = n.get(e, pr), o = Array.isArray(i) ? i.join(Gr) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(Gr);
      return u.forEach(function(c) {
        var s = Zu(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : G.setBaggage(t, G.createBaggage(a));
    }, r.prototype.fields = function() {
      return [pr];
    }, r;
  }()
), po = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qu = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Re(r) {
  var t, e, n = {};
  if (typeof r != "object" || r == null)
    return n;
  try {
    for (var i = po(Object.entries(r)), o = i.next(); !o.done; o = i.next()) {
      var a = Qu(o.value, 2), u = a[0], c = a[1];
      if (!tc(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!ho(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function tc(r) {
  return typeof r == "string" && r.length > 0;
}
function ho(r) {
  return r == null ? !0 : Array.isArray(r) ? ec(r) : _o(r);
}
function ec(r) {
  var t, e, n;
  try {
    for (var i = po(r), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (_o(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function _o(r) {
  switch (typeof r) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function rc() {
  return function(r) {
    v.error(nc(r));
  };
}
function nc(r) {
  return typeof r == "string" ? r : JSON.stringify(ic(r));
}
function ic(r) {
  for (var t = {}, e = r; e !== null; )
    Object.getOwnPropertyNames(e).forEach(function(n) {
      if (!t[n]) {
        var i = e[n];
        i && (t[n] = String(i));
      }
    }), e = Object.getPrototypeOf(e);
  return t;
}
var oc = rc();
function pt(r) {
  try {
    oc(r);
  } catch (t) {
  }
}
var K;
(function(r) {
  r.AlwaysOff = "always_off", r.AlwaysOn = "always_on", r.ParentBasedAlwaysOff = "parentbased_always_off", r.ParentBasedAlwaysOn = "parentbased_always_on", r.ParentBasedTraceIdRatio = "parentbased_traceidratio", r.TraceIdRatio = "traceidratio";
})(K || (K = {}));
var ac = ",", sc = ["OTEL_SDK_DISABLED"];
function uc(r) {
  return sc.indexOf(r) > -1;
}
var cc = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function lc(r) {
  return cc.indexOf(r) > -1;
}
var fc = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function dc(r) {
  return fc.indexOf(r) > -1;
}
var Le = 1 / 0, Pe = 128, pc = 128, hc = 128, vo = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: R.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Le,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Pe,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Le,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Pe,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Le,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Pe,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: pc,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: hc,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: K.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function _c(r, t, e) {
  if (typeof e[r] != "undefined") {
    var n = String(e[r]);
    t[r] = n.toLowerCase() === "true";
  }
}
function vc(r, t, e, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof e[r] != "undefined") {
    var o = Number(e[r]);
    isNaN(o) || (o < n ? t[r] = n : o > i ? t[r] = i : t[r] = o);
  }
}
function gc(r, t, e, n) {
  n === void 0 && (n = ac);
  var i = e[r];
  typeof i == "string" && (t[r] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var mc = {
  ALL: R.ALL,
  VERBOSE: R.VERBOSE,
  DEBUG: R.DEBUG,
  INFO: R.INFO,
  WARN: R.WARN,
  ERROR: R.ERROR,
  NONE: R.NONE
};
function yc(r, t, e) {
  var n = e[r];
  if (typeof n == "string") {
    var i = mc[n.toUpperCase()];
    i != null && (t[r] = i);
  }
}
function go(r) {
  var t = {};
  for (var e in vo) {
    var n = e;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        yc(n, t, r);
        break;
      default:
        if (uc(n))
          _c(n, t, r);
        else if (lc(n))
          vc(n, t, r);
        else if (dc(n))
          gc(n, t, r);
        else {
          var i = r[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Qt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Gt() {
  var r = go(Qt);
  return Object.assign({}, vo, r);
}
function Ec() {
  return go(Qt);
}
function Cn(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 97 && r <= 102 ? r - 87 : r - 55;
}
function ln(r) {
  for (var t = new Uint8Array(r.length / 2), e = 0, n = 0; n < r.length; n += 2) {
    var i = Cn(r.charCodeAt(n)), o = Cn(r.charCodeAt(n + 1));
    t[e++] = i << 4 | o;
  }
  return t;
}
var V = performance, Tc = "1.30.1", Sc = "process.runtime.name", bc = "telemetry.sdk.name", wc = "telemetry.sdk.language", Oc = "telemetry.sdk.version", Ac = Sc, Rc = bc, Lc = wc, Pc = Oc, Nc = "webjs", Mc = Nc, xt, hr = (xt = {}, xt[Rc] = "opentelemetry", xt[Ac] = "browser", xt[Lc] = Mc, xt[Pc] = Tc, xt), Cc = 9, Ic = 6, xc = Math.pow(10, Ic), xe = Math.pow(10, Cc);
function j(r) {
  var t = r / 1e3, e = Math.trunc(t), n = Math.round(r % 1e3 * xc);
  return [e, n];
}
function fn() {
  var r = V.timeOrigin;
  if (typeof r != "number") {
    var t = V;
    r = t.timing && t.timing.fetchStart;
  }
  return r;
}
function St(r) {
  var t = j(fn()), e = j(typeof r == "number" ? r : V.now());
  return mo(t, e);
}
function te(r) {
  if (dn(r))
    return r;
  if (typeof r == "number")
    return r < fn() ? St(r) : j(r);
  if (r instanceof Date)
    return j(r.getTime());
  throw TypeError("Invalid input type");
}
function Dc(r, t) {
  var e = t[0] - r[0], n = t[1] - r[1];
  return n < 0 && (e -= 1, n += xe), [e, n];
}
function it(r) {
  return r[0] * xe + r[1];
}
function ve(r) {
  return r[0] * 1e6 + r[1] / 1e3;
}
function dn(r) {
  return Array.isArray(r) && r.length === 2 && typeof r[0] == "number" && typeof r[1] == "number";
}
function In(r) {
  return dn(r) || typeof r == "number" || r instanceof Date;
}
function mo(r, t) {
  var e = [r[0] + t[0], r[1] + t[1]];
  return e[1] >= xe && (e[1] -= xe, e[0] += 1), e;
}
var M;
(function(r) {
  r[r.SUCCESS = 0] = "SUCCESS", r[r.FAILED = 1] = "FAILED";
})(M || (M = {}));
var Uc = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, yo = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = {});
      var e;
      this._propagators = (e = t.propagators) !== null && e !== void 0 ? e : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return r.prototype.inject = function(t, e, n) {
      var i, o;
      try {
        for (var a = Uc(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, e, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, r.prototype.extract = function(t, e, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, e, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, r.prototype.fields = function() {
      return this._fields.slice();
    }, r;
  }()
), jr = "[_0-9a-z-*/]", kc = "[a-z]" + jr + "{0,255}", Bc = "[a-z0-9]" + jr + "{0,240}@[a-z]" + jr + "{0,13}", Hc = new RegExp("^(?:" + kc + "|" + Bc + ")$"), Gc = /^[ -~]{0,255}[!-~]$/, jc = /,|=/;
function Vc(r) {
  return Hc.test(r);
}
function Fc(r) {
  return Gc.test(r) && !jc.test(r);
}
var xn = 32, $c = 512, Dn = ",", Un = "=", Xc = (
  /** @class */
  function() {
    function r(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return r.prototype.set = function(t, e) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, e), n;
    }, r.prototype.unset = function(t) {
      var e = this._clone();
      return e._internalState.delete(t), e;
    }, r.prototype.get = function(t) {
      return this._internalState.get(t);
    }, r.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(e, n) {
        return e.push(n + Un + t.get(n)), e;
      }, []).join(Dn);
    }, r.prototype._parse = function(t) {
      t.length > $c || (this._internalState = t.split(Dn).reverse().reduce(function(e, n) {
        var i = n.trim(), o = i.indexOf(Un);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Vc(a) && Fc(u) && e.set(a, u);
        }
        return e;
      }, /* @__PURE__ */ new Map()), this._internalState.size > xn && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, xn))));
    }, r.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, r.prototype._clone = function() {
      var t = new r();
      return t._internalState = new Map(this._internalState), t;
    }, r;
  }()
), Ne = "traceparent", _r = "tracestate", zc = "00", qc = "(?!ff)[\\da-f]{2}", Wc = "(?![0]{32})[\\da-f]{32}", Yc = "(?![0]{16})[\\da-f]{16}", Kc = "[\\da-f]{2}", Jc = new RegExp("^\\s?(" + qc + ")-(" + Wc + ")-(" + Yc + ")-(" + Kc + ")(-.*)?\\s?$");
function Zc(r) {
  var t = Jc.exec(r);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Eo = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(t, e, n) {
      var i = O.getSpanContext(t);
      if (!(!i || cn(t) || !ze(i))) {
        var o = zc + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || ot.NONE).toString(16);
        n.set(e, Ne, o), i.traceState && n.set(e, _r, i.traceState.serialize());
      }
    }, r.prototype.extract = function(t, e, n) {
      var i = n.get(e, Ne);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = Zc(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(e, _r);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Xc(typeof c == "string" ? c : void 0);
      }
      return O.setSpanContext(t, a);
    }, r.prototype.fields = function() {
      return [Ne, _r];
    }, r;
  }()
), Qc = "[object Object]", tl = "[object Null]", el = "[object Undefined]", rl = Function.prototype, To = rl.toString, nl = To.call(Object), il = ol(Object.getPrototypeOf, Object), So = Object.prototype, bo = So.hasOwnProperty, gt = Symbol ? Symbol.toStringTag : void 0, wo = So.toString;
function ol(r, t) {
  return function(e) {
    return r(t(e));
  };
}
function kn(r) {
  if (!al(r) || sl(r) !== Qc)
    return !1;
  var t = il(r);
  if (t === null)
    return !0;
  var e = bo.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && To.call(e) === nl;
}
function al(r) {
  return r != null && typeof r == "object";
}
function sl(r) {
  return r == null ? r === void 0 ? el : tl : gt && gt in Object(r) ? ul(r) : cl(r);
}
function ul(r) {
  var t = bo.call(r, gt), e = r[gt], n = !1;
  try {
    r[gt] = void 0, n = !0;
  } catch (o) {
  }
  var i = wo.call(r);
  return n && (t ? r[gt] = e : delete r[gt]), i;
}
function cl(r) {
  return wo.call(r);
}
var ll = 20;
function Oo() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  for (var e = r.shift(), n = /* @__PURE__ */ new WeakMap(); r.length > 0; )
    e = Ao(e, r.shift(), 0, n);
  return e;
}
function vr(r) {
  return De(r) ? r.slice() : r;
}
function Ao(r, t, e, n) {
  e === void 0 && (e = 0);
  var i;
  if (!(e > ll)) {
    if (e++, Me(r) || Me(t) || Ro(t))
      i = vr(t);
    else if (De(r)) {
      if (i = r.slice(), De(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(vr(t[o]));
      else if (qt(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = vr(t[c]);
        }
    } else if (qt(r))
      if (qt(t)) {
        if (!fl(r, t))
          return t;
        i = Object.assign({}, r);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Me(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Bn(r, c, n) || Bn(t, c, n))
              delete i[c];
            else {
              if (qt(l) && qt(f)) {
                var d = n.get(l) || [], h = n.get(f) || [];
                d.push({ obj: r, key: c }), h.push({ obj: t, key: c }), n.set(l, d), n.set(f, h);
              }
              i[c] = Ao(i[c], s, e, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Bn(r, t, e) {
  for (var n = e.get(r[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === r)
      return !0;
  }
  return !1;
}
function De(r) {
  return Array.isArray(r);
}
function Ro(r) {
  return typeof r == "function";
}
function qt(r) {
  return !Me(r) && !De(r) && !Ro(r) && typeof r == "object";
}
function Me(r) {
  return typeof r == "string" || typeof r == "number" || typeof r == "boolean" || typeof r == "undefined" || r instanceof Date || r instanceof RegExp || r === null;
}
function fl(r, t) {
  return !(!kn(r) || !kn(t));
}
var dl = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Lo(r, t) {
  return typeof t == "string" ? r === t : !!r.match(t);
}
function Po(r, t) {
  var e, n;
  if (!t)
    return !1;
  try {
    for (var i = dl(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Lo(r, a))
        return !0;
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return !1;
}
var pl = (
  /** @class */
  function() {
    function r() {
      var t = this;
      this._promise = new Promise(function(e, n) {
        t._resolve = e, t._reject = n;
      });
    }
    return Object.defineProperty(r.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.resolve = function(t) {
      this._resolve(t);
    }, r.prototype.reject = function(t) {
      this._reject(t);
    }, r;
  }()
), hl = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _l = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, vl = (
  /** @class */
  function() {
    function r(t, e) {
      this._callback = t, this._that = e, this._isCalled = !1, this._deferred = new pl();
    }
    return Object.defineProperty(r.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.call = function() {
      for (var t, e = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, _l([this._that], hl(n), !1))).then(function(o) {
            return e._deferred.resolve(o);
          }, function(o) {
            return e._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, r;
  }()
);
function gl(r, t) {
  return new Promise(function(e) {
    S.with(lo(S.active()), function() {
      r.export(t, function(n) {
        e(n);
      });
    });
  });
}
var ml = {
  _export: gl
}, No = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.emit = function(t) {
    }, r;
  }()
), yl = new No(), El = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(t, e, n) {
      return new No();
    }, r;
  }()
), Mo = new El(), Tl = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      this._provider = t, this.name = e, this.version = n, this.options = i;
    }
    return r.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, r.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : yl;
    }, r;
  }()
), Hn = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(t, e, n) {
      var i;
      return (i = this.getDelegateLogger(t, e, n)) !== null && i !== void 0 ? i : new Tl(this, t, e, n);
    }, r.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Mo;
    }, r.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, r.prototype.getDelegateLogger = function(t, e, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, e, n);
    }, r;
  }()
), Sl = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ge = Symbol.for("io.opentelemetry.js.api.logs"), Wt = Sl;
function bl(r, t, e) {
  return function(n) {
    return n === r ? t : e;
  };
}
var Gn = 1, wl = (
  /** @class */
  function() {
    function r() {
      this._proxyLoggerProvider = new Hn();
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalLoggerProvider = function(t) {
      return Wt[ge] ? this.getLoggerProvider() : (Wt[ge] = bl(Gn, t, Mo), this._proxyLoggerProvider.setDelegate(t), t);
    }, r.prototype.getLoggerProvider = function() {
      var t, e;
      return (e = (t = Wt[ge]) === null || t === void 0 ? void 0 : t.call(Wt, Gn)) !== null && e !== void 0 ? e : this._proxyLoggerProvider;
    }, r.prototype.getLogger = function(t, e, n) {
      return this.getLoggerProvider().getLogger(t, e, n);
    }, r.prototype.disable = function() {
      delete Wt[ge], this._proxyLoggerProvider = new Hn();
    }, r;
  }()
), fe = wl.getInstance();
function Ol(r, t, e, n) {
  for (var i = 0, o = r.length; i < o; i++) {
    var a = r[i];
    t && a.setTracerProvider(t), e && a.setMeterProvider(e), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function Al(r) {
  r.forEach(function(t) {
    return t.disable();
  });
}
function Rl(r) {
  var t, e, n = r.tracerProvider || O.getTracerProvider(), i = r.meterProvider || Z.getMeterProvider(), o = r.loggerProvider || fe.getLoggerProvider(), a = (e = (t = r.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && e !== void 0 ? e : [];
  return Ol(a, n, i, o), function() {
    Al(a);
  };
}
function Vr(r) {
  return typeof r == "function";
}
var x = console.error.bind(console);
function Yt(r, t, e) {
  var n = !!r[t] && r.propertyIsEnumerable(t);
  Object.defineProperty(r, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: e
  });
}
function de(r) {
  r && r.logger && (Vr(r.logger) ? x = r.logger : x("new logger isn't a function, not replacing"));
}
function Co(r, t, e) {
  if (!r || !r[t]) {
    x("no original function " + t + " to wrap");
    return;
  }
  if (!e) {
    x("no wrapper function"), x(new Error().stack);
    return;
  }
  if (!Vr(r[t]) || !Vr(e)) {
    x("original object and wrapper must be functions");
    return;
  }
  var n = r[t], i = e(n, t);
  return Yt(i, "__original", n), Yt(i, "__unwrap", function() {
    r[t] === i && Yt(r, t, n);
  }), Yt(i, "__wrapped", !0), Yt(r, t, i), i;
}
function Ll(r, t, e) {
  if (r)
    Array.isArray(r) || (r = [r]);
  else {
    x("must provide one or more modules to patch"), x(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    x("must provide one or more functions to wrap on modules");
    return;
  }
  r.forEach(function(n) {
    t.forEach(function(i) {
      Co(n, i, e);
    });
  });
}
function Io(r, t) {
  if (!r || !r[t]) {
    x("no function to unwrap."), x(new Error().stack);
    return;
  }
  if (!r[t].__unwrap)
    x("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return r[t].__unwrap();
}
function Pl(r, t) {
  if (r)
    Array.isArray(r) || (r = [r]);
  else {
    x("must provide one or more modules to patch"), x(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    x("must provide one or more functions to unwrap on modules");
    return;
  }
  r.forEach(function(e) {
    t.forEach(function(n) {
      Io(e, n);
    });
  });
}
de.wrap = Co;
de.massWrap = Ll;
de.unwrap = Io;
de.massUnwrap = Pl;
var C = de, Fr = function() {
  return Fr = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, Fr.apply(this, arguments);
}, Nl = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.instrumentationName = t, this.instrumentationVersion = e, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = O.getTracer(t, e), this._meter = Z.getMeter(t, e), this._logger = fe.getLogger(t, e), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var t, e = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(e) ? e : [e];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(t) {
      this._config = Fr({ enabled: !0 }, t);
    }, r.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(t, e, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: e }, o);
        }
    }, r;
  }()
), Ml = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Cl = (
  /** @class */
  function(r) {
    Ml(t, r);
    function t(e, n, i) {
      var o = r.call(this, e, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Nl)
);
function I(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var Il = "exception.type", xl = "exception.message", Dl = "exception.stacktrace", Ul = "http.response_content_length", kl = "http.response_content_length_uncompressed", gr = Il, mr = xl, Bl = Dl, Hl = Ul, Gl = kl, jl = "exception", $r = function() {
  return $r = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, $r.apply(this, arguments);
}, Vl = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, jn = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fl = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, $l = (
  /** @class */
  function() {
    function r(t, e, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Ie.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = V.now(), this._performanceOffset = f - (this._performanceStartTime + fn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, e);
    }
    return r.prototype.spanContext = function() {
      return this._spanContext;
    }, r.prototype.setAttribute = function(t, e) {
      return e == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : ho(e) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(e), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, r.prototype.setAttributes = function(t) {
      var e, n;
      try {
        for (var i = Vl(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = jn(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return this;
    }, r.prototype.addEvent = function(t, e, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), In(e) && (In(n) || (n = e), e = void 0);
      var i = Re(e);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, r.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, r.prototype.addLinks = function(t) {
      var e;
      return (e = this.links).push.apply(e, Fl([], jn(t), !1)), this;
    }, r.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = $r({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, r.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, r.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Dc(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, r.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= V.now())
        return St(t + this._performanceOffset);
      if (typeof t == "number")
        return j(t);
      if (t instanceof Date)
        return j(t.getTime());
      if (dn(t))
        return t;
      if (this._startTimeProvided)
        return j(Date.now());
      var e = V.now() - this._performanceStartTime;
      return mo(this.startTime, j(e));
    }, r.prototype.isRecording = function() {
      return this._ended === !1;
    }, r.prototype.recordException = function(t, e) {
      var n = {};
      typeof t == "string" ? n[mr] = t : t && (t.code ? n[gr] = t.code.toString() : t.name && (n[gr] = t.name), t.message && (n[mr] = t.message), t.stack && (n[Bl] = t.stack)), n[gr] || n[mr] ? this.addEvent(jl, n, e) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(r.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, r.prototype._truncateToLimitUtil = function(t, e) {
      return t.length <= e ? t : t.substring(0, e);
    }, r.prototype._truncateToSize = function(t) {
      var e = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (v.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? e._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, r;
  }()
), jt;
(function(r) {
  r[r.NOT_RECORD = 0] = "NOT_RECORD", r[r.RECORD = 1] = "RECORD", r[r.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(jt || (jt = {}));
var Ue = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.shouldSample = function() {
      return {
        decision: jt.NOT_RECORD
      };
    }, r.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, r;
  }()
), Ht = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.shouldSample = function() {
      return {
        decision: jt.RECORD_AND_SAMPLED
      };
    }, r.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, r;
  }()
), yr = (
  /** @class */
  function() {
    function r(t) {
      var e, n, i, o;
      this._root = t.root, this._root || (pt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Ht()), this._remoteParentSampled = (e = t.remoteParentSampled) !== null && e !== void 0 ? e : new Ht(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new Ue(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new Ht(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new Ue();
    }
    return r.prototype.shouldSample = function(t, e, n, i, o, a) {
      var u = O.getSpanContext(t);
      return !u || !ze(u) ? this._root.shouldSample(t, e, n, i, o, a) : u.isRemote ? u.traceFlags & ot.SAMPLED ? this._remoteParentSampled.shouldSample(t, e, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, e, n, i, o, a) : u.traceFlags & ot.SAMPLED ? this._localParentSampled.shouldSample(t, e, n, i, o, a) : this._localParentNotSampled.shouldSample(t, e, n, i, o, a);
    }, r.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, r;
  }()
), Vn = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return r.prototype.shouldSample = function(t, e) {
      return {
        decision: ao(e) && this._accumulate(e) < this._upperBound ? jt.RECORD_AND_SAMPLED : jt.NOT_RECORD
      };
    }, r.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, r.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, r.prototype._accumulate = function(t) {
      for (var e = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        e = (e ^ o) >>> 0;
      }
      return e;
    }, r;
  }()
), Xl = K.AlwaysOn, Dt = 1;
function xo() {
  var r = Gt();
  return {
    sampler: Do(r),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: r.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: r.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: r.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: r.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: r.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: r.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: r.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: r.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function Do(r) {
  switch (r === void 0 && (r = Gt()), r.OTEL_TRACES_SAMPLER) {
    case K.AlwaysOn:
      return new Ht();
    case K.AlwaysOff:
      return new Ue();
    case K.ParentBasedAlwaysOn:
      return new yr({
        root: new Ht()
      });
    case K.ParentBasedAlwaysOff:
      return new yr({
        root: new Ue()
      });
    case K.TraceIdRatio:
      return new Vn(Fn(r));
    case K.ParentBasedTraceIdRatio:
      return new yr({
        root: new Vn(Fn(r))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + r.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Xl + '".'), new Ht();
  }
}
function Fn(r) {
  if (r.OTEL_TRACES_SAMPLER_ARG === void 0 || r.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Dt + "."), Dt;
  var t = Number(r.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + r.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Dt + "."), Dt) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + r.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Dt + "."), Dt) : t;
}
function zl(r) {
  var t = {
    sampler: Do()
  }, e = xo(), n = Object.assign({}, e, t, r);
  return n.generalLimits = Object.assign({}, e.generalLimits, r.generalLimits || {}), n.spanLimits = Object.assign({}, e.spanLimits, r.spanLimits || {}), n;
}
function ql(r) {
  var t, e, n, i, o, a, u, c, s, l, f, d, h = Object.assign({}, r.spanLimits), _ = Ec();
  return h.attributeCountLimit = (a = (o = (i = (e = (t = r.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && e !== void 0 ? e : (n = r.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Pe, h.attributeValueLengthLimit = (d = (f = (l = (c = (u = r.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = r.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : Le, Object.assign({}, r, { spanLimits: h });
}
var Wl = (
  /** @class */
  function() {
    function r(t, e) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Gt();
      this._maxExportBatchSize = typeof (e == null ? void 0 : e.maxExportBatchSize) == "number" ? e.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (e == null ? void 0 : e.maxQueueSize) == "number" ? e.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (e == null ? void 0 : e.scheduledDelayMillis) == "number" ? e.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (e == null ? void 0 : e.exportTimeoutMillis) == "number" ? e.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new vl(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return r.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, r.prototype.onStart = function(t, e) {
    }, r.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & ot.SAMPLED && this._addToBuffer(t);
    }, r.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, r.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, r.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, r.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(e, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          e();
        }).catch(n);
      });
    }, r.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(e, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        S.with(lo(S.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === M.SUCCESS ? e() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            pt(f), n(f);
          });
        });
      });
    }, r.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var e = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, pt(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return e();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return e();
        }, this._scheduledDelayMillis));
      }
    }, r.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, r;
  }()
), Yl = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Uo = (
  /** @class */
  function(r) {
    Yl(t, r);
    function t(e, n) {
      var i = r.call(this, e, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(e) {
      var n = this;
      (e == null ? void 0 : e.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          pt(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          pt(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(Wl)
), Kl = 8, Jl = 16, Zl = (
  /** @class */
  /* @__PURE__ */ function() {
    function r() {
      this.generateTraceId = $n(Jl), this.generateSpanId = $n(Kl);
    }
    return r;
  }()
), me = Array(32);
function $n(r) {
  return function() {
    for (var e = 0; e < r * 2; e++)
      me[e] = Math.floor(Math.random() * 16) + 48, me[e] >= 58 && (me[e] += 39);
    return String.fromCharCode.apply(null, me.slice(0, r * 2));
  };
}
var Ql = (
  /** @class */
  function() {
    function r(t, e, n) {
      this._tracerProvider = n;
      var i = zl(e);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = e.idGenerator || new Zl(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return r.prototype.startSpan = function(t, e, n) {
      var i, o, a;
      e === void 0 && (e = {}), n === void 0 && (n = S.active()), e.root && (n = O.deleteSpan(n));
      var u = O.getSpan(n);
      if (cn(n)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = O.wrapSpanContext(io);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !s || !O.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, h = s.spanId);
      var _ = (i = e.kind) !== null && i !== void 0 ? i : oe.INTERNAL, p = ((o = e.links) !== null && o !== void 0 ? o : []).map(function(D) {
        return {
          context: D.context,
          attributes: Re(D.attributes)
        };
      }), g = Re(e.attributes), m = this._sampler.shouldSample(n, f, t, _, g, p);
      d = (a = m.traceState) !== null && a !== void 0 ? a : d;
      var y = m.decision === Ce.RECORD_AND_SAMPLED ? ot.SAMPLED : ot.NONE, w = { traceId: f, spanId: l, traceFlags: y, traceState: d };
      if (m.decision === Ce.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = O.wrapSpanContext(w);
        return c;
      }
      var L = Re(Object.assign(g, m.attributes)), B = new $l(this, n, t, w, _, h, p, e.startTime, void 0, L);
      return B;
    }, r.prototype.startActiveSpan = function(t, e, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = e : arguments.length === 3 ? (o = e, u = n) : (o = e, a = n, u = i);
        var c = a != null ? a : S.active(), s = this.startSpan(t, o, c), l = O.setSpan(c, s);
        return S.with(l, u, void 0, s);
      }
    }, r.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, r.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, r.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, r;
  }()
), tf = "service.name", ef = "telemetry.sdk.name", rf = "telemetry.sdk.language", nf = "telemetry.sdk.version", of = tf, Xn = ef, zn = rf, qn = nf;
function af() {
  return "unknown_service";
}
var ct = function() {
  return ct = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, ct.apply(this, arguments);
}, sf = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, uf = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, cf = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ae = (
  /** @class */
  function() {
    function r(t, e) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = e != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = e == null ? void 0 : e.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return r.empty = function() {
      return r.EMPTY;
    }, r.default = function() {
      var t;
      return new r((t = {}, t[of] = af(), t[zn] = hr[zn], t[Xn] = hr[Xn], t[qn] = hr[qn], t));
    }, Object.defineProperty(r.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.waitForAsyncAttributes = function() {
      return sf(this, void 0, void 0, function() {
        return uf(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.merge = function(t) {
      var e = this, n;
      if (!t)
        return this;
      var i = ct(ct({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new r(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = cf(a, 2), s = c[0], l = c[1];
        return ct(ct(ct(ct({}, e._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new r(i, o);
    }, r.EMPTY = new r({}), r;
  }()
), ye = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Wn = (
  /** @class */
  function() {
    function r(t) {
      this._spanProcessors = t;
    }
    return r.prototype.forceFlush = function() {
      var t, e, n = [];
      try {
        for (var i = ye(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (e = i.return) && e.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          pt(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, r.prototype.onStart = function(t, e) {
      var n, i;
      try {
        for (var o = ye(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, e);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, r.prototype.onEnd = function(t) {
      var e, n;
      try {
        for (var i = ye(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
    }, r.prototype.shutdown = function() {
      var t, e, n = [];
      try {
        for (var i = ye(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (e = i.return) && e.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, r;
  }()
), lf = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.onStart = function(t, e) {
    }, r.prototype.onEnd = function(t) {
    }, r.prototype.shutdown = function() {
      return Promise.resolve();
    }, r.prototype.forceFlush = function() {
      return Promise.resolve();
    }, r;
  }()
), ff = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, df = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, mt;
(function(r) {
  r[r.resolved = 0] = "resolved", r[r.timeout = 1] = "timeout", r[r.error = 2] = "error", r[r.unresolved = 3] = "unresolved";
})(mt || (mt = {}));
var pf = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = {});
      var e, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Oo({}, xo(), ql(t));
      if (this.resource = (e = i.resource) !== null && e !== void 0 ? e : ae.empty(), i.mergeResourceWithDefaults && (this.resource = ae.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = df([], ff(t.spanProcessors), !1), this.activeSpanProcessor = new Wn(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new Uo(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new lf();
      }
    }
    return r.prototype.getTracer = function(t, e, n) {
      var i = t + "@" + (e || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ql({ name: t, version: e, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, r.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(e) {
        return v.error("Error while trying to shutdown current span processor", e);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Wn(this._registeredSpanProcessors);
    }, r.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, r.prototype.register = function(t) {
      t === void 0 && (t = {}), O.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && S.setGlobalContextManager(t.contextManager), t.propagator && G.setGlobalPropagator(t.propagator);
    }, r.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, e = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = mt.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== mt.timeout && (o = mt.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = mt.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(e).then(function(o) {
          var a = o.filter(function(u) {
            return u !== mt.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, r.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, r.prototype._getPropagator = function(t) {
      var e;
      return (e = this.constructor._registeredPropagators.get(t)) === null || e === void 0 ? void 0 : e();
    }, r.prototype._getSpanExporter = function(t) {
      var e;
      return (e = this.constructor._registeredExporters.get(t)) === null || e === void 0 ? void 0 : e();
    }, r.prototype._buildPropagatorFromEnv = function() {
      var t = this, e = Array.from(new Set(Gt().OTEL_PROPAGATORS)), n = e.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return e.length === 1 ? i[0] : new yo({
          propagators: i
        });
    }, r.prototype._buildExporterFromEnv = function() {
      var t = Gt().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var e = this._getSpanExporter(t);
        return e || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), e;
      }
    }, r._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Eo();
      }],
      ["baggage", function() {
        return new fo();
      }]
    ]), r._registeredExporters = /* @__PURE__ */ new Map(), r;
  }()
), hf = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _f = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, ko = (
  /** @class */
  function() {
    function r() {
      this._enabled = !1, this._currentContext = vt;
    }
    return r.prototype._bindFunction = function(t, e) {
      t === void 0 && (t = vt);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return e.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: e.length
      }), i;
    }, r.prototype.active = function() {
      return this._currentContext;
    }, r.prototype.bind = function(t, e) {
      return t === void 0 && (t = this.active()), typeof e == "function" ? this._bindFunction(t, e) : e;
    }, r.prototype.disable = function() {
      return this._currentContext = vt, this._enabled = !1, this;
    }, r.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = vt, this);
    }, r.prototype.with = function(t, e, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || vt;
      try {
        return e.call.apply(e, _f([n], hf(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, r;
  }()
), vf = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), gf = (
  /** @class */
  function(r) {
    vf(t, r);
    function t(e) {
      e === void 0 && (e = {});
      var n = r.call(this, e) || this;
      if (e.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (e.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(e) {
      e === void 0 && (e = {}), e.contextManager === void 0 && (e.contextManager = new ko()), e.contextManager && e.contextManager.enable(), r.prototype.register.call(this, e);
    }, t;
  }(pf)
), E;
(function(r) {
  r.CONNECT_END = "connectEnd", r.CONNECT_START = "connectStart", r.DECODED_BODY_SIZE = "decodedBodySize", r.DOM_COMPLETE = "domComplete", r.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", r.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", r.DOM_INTERACTIVE = "domInteractive", r.DOMAIN_LOOKUP_END = "domainLookupEnd", r.DOMAIN_LOOKUP_START = "domainLookupStart", r.ENCODED_BODY_SIZE = "encodedBodySize", r.FETCH_START = "fetchStart", r.LOAD_EVENT_END = "loadEventEnd", r.LOAD_EVENT_START = "loadEventStart", r.NAVIGATION_START = "navigationStart", r.REDIRECT_END = "redirectEnd", r.REDIRECT_START = "redirectStart", r.REQUEST_START = "requestStart", r.RESPONSE_END = "responseEnd", r.RESPONSE_START = "responseStart", r.SECURE_CONNECTION_START = "secureConnectionStart", r.UNLOAD_EVENT_END = "unloadEventEnd", r.UNLOAD_EVENT_START = "unloadEventStart";
})(E || (E = {}));
var Er;
function mf() {
  return Er || (Er = document.createElement("a")), Er;
}
function ht(r, t) {
  return t in r;
}
function N(r, t, e, n) {
  var i = void 0, o = void 0;
  ht(e, t) && typeof e[t] == "number" && (i = e[t]);
  var a = E.FETCH_START;
  if (ht(e, a) && typeof e[a] == "number" && (o = e[a]), i !== void 0 && o !== void 0 && i >= o)
    return r.addEvent(t, i), r;
}
function Vt(r, t, e) {
  e === void 0 && (e = !1), e || (N(r, E.FETCH_START, t), N(r, E.DOMAIN_LOOKUP_START, t), N(r, E.DOMAIN_LOOKUP_END, t), N(r, E.CONNECT_START, t), ht(t, "name") && t.name.startsWith("https:") && N(r, E.SECURE_CONNECTION_START, t), N(r, E.CONNECT_END, t), N(r, E.REQUEST_START, t), N(r, E.RESPONSE_START, t), N(r, E.RESPONSE_END, t));
  var n = t[E.ENCODED_BODY_SIZE];
  n !== void 0 && r.setAttribute(Hl, n);
  var i = t[E.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && r.setAttribute(Gl, i);
}
function yf(r) {
  return r.slice().sort(function(t, e) {
    var n = t[E.FETCH_START], i = e[E.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Bo() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function Ho(r, t, e, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = nt(r);
  r = a.toString();
  var u = Tf(r, t, e, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = yf(u);
  if (a.origin !== Bo() && c.length > 1) {
    var s = c[0], l = Ef(c, s[E.RESPONSE_END], e), f = s[E.RESPONSE_END], d = l[E.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Ef(r, t, e) {
  for (var n = it(e), i = it(te(t)), o = r[1], a, u = r.length, c = 1; c < u; c++) {
    var s = r[c], l = it(te(s[E.FETCH_START])), f = it(te(s[E.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Tf(r, t, e, n, i, o) {
  var a = it(t), u = it(e), c = n.filter(function(s) {
    var l = it(te(s[E.FETCH_START])), f = it(te(s[E.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === r && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function nt(r) {
  if (typeof URL == "function")
    return new URL(r, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = mf();
  return t.href = r, t;
}
function Go(r, t) {
  if (r.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var e = bf(r, t);
  if (t && e.indexOf("@id") > 0)
    return e;
  var n = "";
  return r.parentNode && (n += Go(r.parentNode, !1)), n += e, n;
}
function Sf(r) {
  if (!r.parentNode)
    return 0;
  var t = [r.nodeType];
  r.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var e = Array.from(r.parentNode.childNodes);
  return e = e.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === r.localName;
  }), e.length >= 1 ? e.indexOf(r) + 1 : 0;
}
function bf(r, t) {
  var e = r.nodeType, n = Sf(r), i = "";
  if (e === Node.ELEMENT_NODE) {
    var o = r.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = r.localName;
  } else if (e === Node.TEXT_NODE || e === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (e === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function jo(r, t) {
  var e = t || [];
  (typeof e == "string" || e instanceof RegExp) && (e = [e]);
  var n = nt(r);
  return n.origin === Bo() ? !0 : e.some(function(i) {
    return Lo(r, i);
  });
}
var Xr = function() {
  return Xr = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, Xr.apply(this, arguments);
}, wf = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.instrumentationName = t, this.instrumentationVersion = e, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = O.getTracer(t, e), this._meter = Z.getMeter(t, e), this._logger = fe.getLogger(t, e), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var t, e = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(e) ? e : [e];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(t) {
      this._config = Xr({ enabled: !0 }, t);
    }, r.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(t, e, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: e }, o);
        }
    }, r;
  }()
), Of = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Af = (
  /** @class */
  function(r) {
    Of(t, r);
    function t(e, n, i) {
      var o = r.call(this, e, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(wf)
);
function Yn(r, t, e) {
  var n, i;
  try {
    i = r();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var ee;
(function(r) {
  r.DOCUMENT_LOAD = "documentLoad", r.DOCUMENT_FETCH = "documentFetch", r.RESOURCE_FETCH = "resourceFetch";
})(ee || (ee = {}));
var Rf = "0.44.0", Lf = "@opentelemetry/instrumentation-document-load";
const Pf = "http.url", Nf = "http.user_agent", Tr = Pf, Mf = Nf;
var ke;
(function(r) {
  r.FIRST_PAINT = "firstPaint", r.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ke || (ke = {}));
var Cf = function() {
  var r, t, e = {}, n = (t = (r = V).getEntriesByType) === null || t === void 0 ? void 0 : t.call(r, "navigation")[0];
  if (n) {
    var i = Object.values(E);
    i.forEach(function(u) {
      if (ht(n, u)) {
        var c = n[u];
        typeof c == "number" && (e[u] = c);
      }
    });
  } else {
    var o = V, a = o.timing;
    if (a) {
      var i = Object.values(E);
      i.forEach(function(c) {
        if (ht(a, c)) {
          var s = a[c];
          typeof s == "number" && (e[c] = s);
        }
      });
    }
  }
  return e;
}, Kn = {
  "first-paint": ke.FIRST_PAINT,
  "first-contentful-paint": ke.FIRST_CONTENTFUL_PAINT
}, If = function(r) {
  var t, e, n = (e = (t = V).getEntriesByType) === null || e === void 0 ? void 0 : e.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    ht(Kn, o) && r.addEvent(Kn[o], a);
  });
}, xf = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Df = (
  /** @class */
  function(r) {
    xf(t, r);
    function t(e) {
      e === void 0 && (e = {});
      var n = r.call(this, Lf, Rf, e) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var e = this;
      window.setTimeout(function() {
        e._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(e) {
      var n = this, i, o, a = (o = (i = V).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, e);
      });
    }, t.prototype._collectPerformance = function() {
      var e = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Ne;
      }), i = Cf(), o = n && n.content || "";
      S.with(G.extract(vt, { traceparent: o }), function() {
        var a, u = e._startSpan(ee.DOCUMENT_LOAD, E.FETCH_START, i);
        u && (S.with(O.setSpan(S.active(), u), function() {
          var c = e._startSpan(ee.DOCUMENT_FETCH, E.FETCH_START, i);
          c && (c.setAttribute(Tr, location.href), S.with(O.setSpan(S.active(), c), function() {
            var s;
            e.getConfig().ignoreNetworkEvents || Vt(c, i), e._addCustomAttributesOnSpan(c, (s = e.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), e._endSpan(c, E.RESPONSE_END, i);
          }));
        }), u.setAttribute(Tr, location.href), u.setAttribute(Mf, navigator.userAgent), e._addResourcesSpans(u), e.getConfig().ignoreNetworkEvents || (N(u, E.FETCH_START, i), N(u, E.UNLOAD_EVENT_START, i), N(u, E.UNLOAD_EVENT_END, i), N(u, E.DOM_INTERACTIVE, i), N(u, E.DOM_CONTENT_LOADED_EVENT_START, i), N(u, E.DOM_CONTENT_LOADED_EVENT_END, i), N(u, E.DOM_COMPLETE, i), N(u, E.LOAD_EVENT_START, i), N(u, E.LOAD_EVENT_END, i)), e.getConfig().ignorePerformancePaintEvents || If(u), e._addCustomAttributesOnSpan(u, (a = e.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), e._endSpan(u, E.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(e, n, i) {
      e && (ht(i, n) ? e.end(i[n]) : e.end());
    }, t.prototype._initResourceSpan = function(e, n) {
      var i, o = this._startSpan(ee.RESOURCE_FETCH, E.FETCH_START, e, n);
      o && (o.setAttribute(Tr, e.name), this.getConfig().ignoreNetworkEvents || Vt(o, e), this._addCustomAttributesOnResourceSpan(o, e, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, E.RESPONSE_END, e));
    }, t.prototype._startSpan = function(e, n, i, o) {
      if (ht(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(e, {
          startTime: i[n]
        }, o ? O.setSpan(S.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(e, n) {
      var i = this;
      n && Yn(function() {
        return n(e);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(e, n, i) {
      var o = this;
      i && Yn(function() {
        return i(e, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Af)
), zr = function() {
  return zr = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, zr.apply(this, arguments);
}, Uf = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.instrumentationName = t, this.instrumentationVersion = e, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = O.getTracer(t, e), this._meter = Z.getMeter(t, e), this._logger = fe.getLogger(t, e), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var t, e = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(e) ? e : [e];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(t) {
      this._config = zr({ enabled: !0 }, t);
    }, r.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(t, e, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: e }, o);
        }
    }, r;
  }()
), kf = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Bf = (
  /** @class */
  function(r) {
    kf(t, r);
    function t(e, n, i) {
      var o = r.call(this, e, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Uf)
);
function Hf(r, t, e) {
  var n, i;
  try {
    i = r();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function Gf(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var Be;
(function(r) {
  r.COMPONENT = "component", r.HTTP_ERROR_NAME = "http.error_name", r.HTTP_STATUS_TEXT = "http.status_text";
})(Be || (Be = {}));
var jf = "http.method", Vf = "http.url", Ff = "http.host", $f = "http.scheme", Xf = "http.status_code", zf = "http.user_agent", qf = "http.request_content_length_uncompressed", Wf = jf, Yf = Vf, Kf = Ff, Jf = $f, Zf = Xf, Qf = zf, td = qf, ed = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, rd = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, nd = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, id = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vo = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function od() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  if (r[0] instanceof URL || typeof r[0] == "string") {
    var e = r[1];
    if (!(e != null && e.body))
      return Promise.resolve();
    if (e.body instanceof ReadableStream) {
      var n = ad(e.body), i = n.body, o = n.length;
      return e.body = i, o;
    } else
      return Promise.resolve(sd(e.body));
  } else {
    var a = r[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return qr(u);
    }) : Promise.resolve();
  }
}
function ad(r) {
  if (!r.pipeThrough)
    return Vo.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: r,
      length: Promise.resolve(void 0)
    };
  var t = 0, e, n = new Promise(function(o) {
    e = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return ed(this, void 0, void 0, function() {
        var u;
        return rd(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      e(t);
    }
  });
  return {
    body: r.pipeThrough(i),
    length: n
  };
}
function sd(r) {
  if (typeof Document != "undefined" && r instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (r instanceof Blob)
    return r.size;
  if (r.byteLength !== void 0)
    return r.byteLength;
  if (r instanceof FormData)
    return cd(r);
  if (r instanceof URLSearchParams)
    return qr(r.toString());
  if (typeof r == "string")
    return qr(r);
  Vo.warn("unknown body type");
}
var ud = new TextEncoder();
function qr(r) {
  return ud.encode(r).byteLength;
}
function cd(r) {
  var t, e, n = 0;
  try {
    for (var i = nd(r.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = id(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Jn = "0.57.2", ld = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), fd = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, dd = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, Sr, pd = 300, Zn = typeof process == "object" && ((Sr = process.release) === null || Sr === void 0 ? void 0 : Sr.name) === "node", hd = (
  /** @class */
  function(r) {
    ld(t, r);
    function t(e) {
      e === void 0 && (e = {});
      var n = r.call(this, "@opentelemetry/instrumentation-fetch", Jn, e) || this;
      return n.component = "fetch", n.version = Jn, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(e, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[E.FETCH_START]
      }, O.setSpan(S.active(), e));
      Vt(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[E.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(e, n) {
      var i = nt(n.url);
      e.setAttribute(Zf, n.status), n.statusText != null && e.setAttribute(Be.HTTP_STATUS_TEXT, n.statusText), e.setAttribute(Kf, i.host), e.setAttribute(Jf, i.protocol.replace(":", "")), typeof navigator != "undefined" && e.setAttribute(Qf, navigator.userAgent);
    }, t.prototype._addHeaders = function(e, n) {
      if (!jo(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        G.inject(S.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (e instanceof Request)
        G.inject(S.active(), e.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (e.headers instanceof Headers)
        G.inject(S.active(), e.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (e.headers instanceof Map)
        G.inject(S.active(), e.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        G.inject(S.active(), i), e.headers = Object.assign({}, i, e.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(e, n) {
      var i;
      if (n === void 0 && (n = {}), Po(e, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: oe.CLIENT,
        attributes: (i = {}, i[Be.COMPONENT] = this.moduleName, i[Wf] = o, i[Yf] = e, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(e, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = Ho(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(e, c), this._markResourceAsUsed(c)), Vt(e, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(e) {
      this._usedResources.add(e);
    }, t.prototype._endSpan = function(e, n, i) {
      var o = this, a = j(Date.now()), u = St();
      this._addFinalSpanAttributes(e, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(e, n, u), o._tasksCount--, o._clearResources(), e.end(a);
      }, pd);
    }, t.prototype._patchConstructor = function() {
      var e = this;
      return function(n) {
        var i = e;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = nt(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && od.apply(void 0, dd([], fd(a), !1)).then(function(m) {
            m && f.setAttribute(td, m);
          }).catch(function(m) {
            i._diag.warn("getFetchBodyLength", m);
          });
          function h(m, y) {
            i._applyAttributesAfterFetch(m, l, y), i._endSpan(m, d, {
              status: y.status || 0,
              statusText: y.message,
              url: s
            });
          }
          function _(m, y) {
            i._applyAttributesAfterFetch(m, l, y), y.status >= 200 && y.status < 400 ? i._endSpan(m, d, y) : i._endSpan(m, d, {
              status: y.status,
              statusText: y.statusText,
              url: s
            });
          }
          function p(m, y, w) {
            try {
              var L = w.clone(), B = w.clone(), D = L.body;
              if (D) {
                var Nt = D.getReader(), $t = function() {
                  Nt.read().then(function(Mt) {
                    var U = Mt.done;
                    U ? _(m, B) : $t();
                  }, function(Mt) {
                    h(m, Mt);
                  });
                };
                $t();
              } else
                _(m, w);
            } finally {
              y(w);
            }
          }
          function g(m, y, w) {
            try {
              h(m, w);
            } finally {
              y(w);
            }
          }
          return new Promise(function(m, y) {
            return S.with(O.setSpan(S.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(p.bind(c, f, m), g.bind(c, f, y));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(e, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && Hf(function() {
        return a(e, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(e) {
      var n = St(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: e };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === e && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: e };
    }, t.prototype.enable = function() {
      if (Zn) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      Gf(fetch) && (this._unwrap(Qt, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Qt, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Zn || (this._unwrap(Qt, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Bf)
), Wr = function() {
  return Wr = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, Wr.apply(this, arguments);
}, _d = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.instrumentationName = t, this.instrumentationVersion = e, this._config = {}, this._wrap = C.wrap, this._unwrap = C.unwrap, this._massWrap = C.massWrap, this._massUnwrap = C.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = O.getTracer(t, e), this._meter = Z.getMeter(t, e), this._logger = fe.getLogger(t, e), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var t, e = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(e) ? e : [e];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(t) {
      this._config = Wr({ enabled: !0 }, t);
    }, r.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(t, e, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: e }, o);
        }
    }, r;
  }()
), vd = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), gd = (
  /** @class */
  function(r) {
    vd(t, r);
    function t(e, n, i) {
      var o = r.call(this, e, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(_d)
);
function md(r, t, e) {
  var n, i;
  try {
    i = r();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function Qn(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var yd = "http.method", Ed = "http.url", Td = "http.host", Sd = "http.scheme", bd = "http.status_code", wd = "http.user_agent", Od = "http.request_content_length_uncompressed", Ad = yd, Rd = Ed, Ld = Td, Pd = Sd, Nd = bd, Md = wd, Cd = Od, rt;
(function(r) {
  r.METHOD_OPEN = "open", r.METHOD_SEND = "send", r.EVENT_ABORT = "abort", r.EVENT_ERROR = "error", r.EVENT_LOAD = "loaded", r.EVENT_TIMEOUT = "timeout";
})(rt || (rt = {}));
var Id = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xd = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Dd = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Ud(r) {
  if (typeof Document != "undefined" && r instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (r instanceof Blob)
    return r.size;
  if (r.byteLength !== void 0)
    return r.byteLength;
  if (r instanceof FormData)
    return Bd(r);
  if (r instanceof URLSearchParams)
    return ti(r.toString());
  if (typeof r == "string")
    return ti(r);
  Dd.warn("unknown body type");
}
var kd = new TextEncoder();
function ti(r) {
  return kd.encode(r).byteLength;
}
function Bd(r) {
  var t, e, n = 0;
  try {
    for (var i = Id(r.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = xd(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var ei = "0.57.2", Yr;
(function(r) {
  r.HTTP_STATUS_TEXT = "http.status_text";
})(Yr || (Yr = {}));
var Hd = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Gd = 300, jd = (
  /** @class */
  function(r) {
    Hd(t, r);
    function t(e) {
      e === void 0 && (e = {});
      var n = r.call(this, "@opentelemetry/instrumentation-xml-http-request", ei, e) || this;
      return n.component = "xml-http-request", n.version = ei, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(e, n) {
      var i = nt(n).href;
      if (!jo(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        G.inject(S.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      G.inject(S.active(), a), Object.keys(a).forEach(function(u) {
        e.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(e, n) {
      var i = this;
      S.with(O.setSpan(S.active(), e), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[E.FETCH_START]
        });
        Vt(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[E.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(e, n, i) {
      if (typeof i == "string") {
        var o = nt(i);
        n.status !== void 0 && e.setAttribute(Nd, n.status), n.statusText !== void 0 && e.setAttribute(Yr.HTTP_STATUS_TEXT, n.statusText), e.setAttribute(Ld, o.host), e.setAttribute(Pd, o.protocol.replace(":", "")), e.setAttribute(Md, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(e, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && md(function() {
        return o(e, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(e, n) {
      var i = this._xhrMem.get(e);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = nt(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (V.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(e, n, i, o, a) {
      if (!(!i || !o || !a || !e.createdResources)) {
        var u = e.createdResources.entries;
        (!u || !u.length) && (u = V.getEntriesByType("resource"));
        var c = Ho(nt(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), Vt(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(e) {
      var n = this._xhrMem.get(e);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(e);
      }
    }, t.prototype._createSpan = function(e, n, i) {
      var o;
      if (Po(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: oe.CLIENT,
        attributes: (o = {}, o[Ad] = i, o[Rd] = nt(n).toString(), o)
      });
      return u.addEvent(rt.METHOD_OPEN), this._cleanPreviousSpanInformation(e), this._xhrMem.set(e, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(e) {
      this._usedResources.add(e);
    }, t.prototype._patchOpen = function() {
      var e = this;
      return function(n) {
        var i = e;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var e = this;
      function n(l, f, d, h) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = f.span, g = f.spanUrl, m = f.sendStartTime;
        p && (e._findResourceAndAddNetworkEvents(f, p, g, m, d), p.addEvent(l, h), e._addFinalSpanAttributes(p, f, g), p.end(h), e._tasksCount--), e._clearResources();
      }
      function i(l, f) {
        var d = e._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, e._xhrMem.delete(f), d.span && e._applyAttributesAfterXHR(d.span, f);
          var h = St(), _ = Date.now();
          setTimeout(function() {
            n(l, d, h, _);
          }, Gd);
        }
      }
      function o() {
        i(rt.EVENT_ERROR, this);
      }
      function a() {
        i(rt.EVENT_ABORT, this);
      }
      function u() {
        i(rt.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(rt.EVENT_LOAD, this) : i(rt.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = e._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = e._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var g = p.span, m = p.spanUrl;
          if (g && m) {
            if (e.getConfig().measureRequestSize && (h != null && h[0])) {
              var y = h[0], w = Ud(y);
              w !== void 0 && g.setAttribute(Cd, w);
            }
            S.with(O.setSpan(S.active(), g), function() {
              e._tasksCount++, p.sendStartTime = St(), g.addEvent(rt.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, e._addHeaders(d, m), e._addResourceObserver(d, m);
            });
          }
          return l.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), Qn(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), Qn(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(gd)
);
const ri = (r, t, e) => {
  const n = Fo(
    t,
    r.headers,
    e
  );
  return P(b({}, r), {
    headers: n
  });
}, Fo = (r, t, e) => {
  var i, o;
  const n = b({}, t);
  return e ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...e].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...Vd, ...r].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, Vd = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], Fd = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], $d = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), Xd = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function zd(r) {
  return !!(r.includes("/sdk/evalx") && r.match($d) || r.includes("/eval/") && r.match(Xd));
}
const $o = "X-Highlight-Request", ni = (r) => {
  let t = r;
  return !r.startsWith("https://") && !r.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, qd = (r, {
  headersToRedact: t,
  headersToRecord: e,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = r;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = On(l, ["request", "response"]);
  return b({
    request: ri(o, t, e),
    response: ri(a, t, e)
  }, u);
}, Zv = (r, t, e, n) => {
  r.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = r.reduce((c, s) => {
    const l = ni(s.name);
    return s.initiatorType === e ? c[e][l] = [
      ...c[e][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const l = ni(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[e]) {
    const s = o[e][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = qd(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, Wd = (r) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => r.toLocaleLowerCase().includes(t)
), Yd = (r) => zd(r), Kd = (r, t) => t.some(
  (e) => r.toLocaleLowerCase().includes(e)
), pn = (r, t, e) => !Kd(r, t) && !Yd(r) && !Wd(r), hn = (r, t, e) => {
  var o;
  if (e.some(
    (a) => r.toLowerCase().includes(a)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && n.push(window.location.host)) : t instanceof Array && (n = t);
  let i = !1;
  return n.forEach((a) => {
    r.match(a) && (i = !0);
  }), i;
};
function Jd(r) {
  for (var t = "", e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = e.length, i = 0; i < r; i++)
    t += e.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Xo = () => {
  const r = Jd(10), t = _v(), e = t == null ? void 0 : t.spanContext().traceId;
  return [ut(), e != null ? e : r];
}, zo = (r, t) => r + "/" + t, Qv = (r, t, e, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!pn(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [f, d] = Xo();
    hn(
      this._url,
      e,
      n
    ) && this.setRequestHeader(
      $o,
      zo(f, d)
    );
    const h = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && l) {
      const p = ii(l, _.url);
      p && (this._body = p, _.body = lt(
        p,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return z(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const y = this.getAllResponseHeaders().trim().split(/[\r\n]+/), w = {};
          if (y.forEach(function(L) {
            const B = L.split(": "), D = B.shift();
            w[D] = B.join(": ");
          }), p.headers = w, l) {
            const L = ii(l, _.url);
            L && (_.body = lt(
              L,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = lt(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const L = yield this.response.text();
                p.body = lt(
                  L,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (L) {
              }
          } else
            try {
              p.body = lt(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (L) {
            }
        }
        r({
          request: _,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return z(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        r({
          request: _,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, ii = (r, t) => {
  if (typeof r == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (r.includes("pushPayload") || r.includes("pushSessionEvents"))))
      return r;
  } else if (typeof r == "object" || typeof r == "number" || typeof r == "boolean")
    return Bt(r);
  return null;
}, oi = 64 * 1024, Zd = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, lt = (r, t, e, n) => {
  var o, a, u;
  let i = oi;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = Zd[c]) != null ? u : oi;
  }
  if (r) {
    if (t)
      try {
        const c = JSON.parse(r);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            t.includes(
              l.toLocaleLowerCase()
            ) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), r = JSON.stringify(c);
      } catch (c) {
      }
    if (e)
      try {
        const c = JSON.parse(r);
        Object.keys(c).forEach((s) => {
          e.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), r = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    r = r.slice(0, i);
  } catch (c) {
  }
  return r;
}, tg = (r, t, e, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = Qd(u, c);
    if (!pn(
      l,
      t
    ))
      return a.call(this, u, c);
    const [f, d] = Xo();
    if (hn(l, e, n)) {
      c = c || {};
      let g = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([m, y]) => g.set(m, y)
      ), g.set(
        $o,
        zo(f, d)
      ), c.headers = Object.fromEntries(g.entries());
    }
    const h = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, _ = !n.some(
      (g) => l.toLowerCase().includes(g)
    );
    _ && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = lt(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return tp(
      p,
      h,
      r,
      _,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, Qd = (r, t) => {
  const e = t && t.method || typeof r == "object" && "method" in r && r.method || "GET";
  let n;
  return typeof r == "object" ? "url" in r && r.url ? n = r.url : n = r.toString() : n = r, {
    method: e,
    url: n
  };
}, tp = (r, t, e, n, i, o) => {
  const a = (u) => z(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = P(b({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = P(b({}, c), {
      status: u.status
    }), n && (c.body = yield qo(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = P(b({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && e({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  r.then(a).catch(() => {
  });
}, qo = (r, t, e) => z(void 0, null, function* () {
  let n;
  try {
    const o = r.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let l = c.value;
        s += u.decode(l);
      }
      n = s, n = lt(
        n,
        e,
        t,
        r.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Wo = (
  /** @class */
  function() {
    function r(t) {
      this._delegate = t;
    }
    return r.prototype.export = function(t, e) {
      this._delegate.export(t, e);
    }, r.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, r.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, r;
  }()
), ep = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), ai = (
  /** @class */
  function(r) {
    ep(t, r);
    function t(e, n, i) {
      var o = r.call(this, e) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function rp(r) {
  if (!Number.isNaN(r) && Number.isFinite(r) && r > 0)
    return r;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + r + "')");
}
function np(r) {
  if (r != null)
    return function() {
      return r;
    };
}
function ip(r, t, e) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: rp((i = (n = r.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : e.timeoutMillis),
    concurrencyLimit: (a = (o = r.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : e.concurrencyLimit,
    compression: (c = (u = r.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : e.compression
  };
}
function op() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var ap = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, sp = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, up = (
  /** @class */
  function() {
    function r(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return r.prototype.pushPromise = function(t) {
      var e = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = e._sendingPromises.indexOf(t);
        e._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, r.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, r.prototype.awaitAll = function() {
      return ap(this, void 0, void 0, function() {
        return sp(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function cp(r) {
  return new up(r.concurrencyLimit);
}
function lp(r) {
  return Object.prototype.hasOwnProperty.call(r, "partialSuccess");
}
function fp() {
  return {
    handleResponse: function(r) {
      r == null || !lp(r) || r.partialSuccess == null || Object.keys(r.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(r.partialSuccess));
    }
  };
}
var dp = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, pp = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, hp = (
  /** @class */
  function() {
    function r(t, e, n, i, o) {
      this._transport = t, this._serializer = e, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return r.prototype.export = function(t, e) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        e({
          code: M.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        e({
          code: M.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          e({
            code: M.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          e({
            code: M.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? e({
          code: M.FAILED,
          error: new ai("Export failed with retryable status")
        }) : e({
          code: M.FAILED,
          error: new ai("Export failed with unknown error")
        });
      }, function(o) {
        return e({
          code: M.FAILED,
          error: o
        });
      }));
    }, r.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, r.prototype.shutdown = function() {
      return dp(this, void 0, void 0, function() {
        return pp(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function _p(r, t) {
  return new hp(r.transport, r.serializer, fp(), r.promiseHandler, t.timeout);
}
function Yo(r, t, e) {
  return _p({
    transport: e,
    serializer: t,
    promiseHandler: cp(r)
  }, { timeout: r.timeoutMillis });
}
function Ko(r) {
  var t = BigInt(1e9);
  return BigInt(r[0]) * t + BigInt(r[1]);
}
function vp(r) {
  var t = Number(BigInt.asUintN(32, r)), e = Number(BigInt.asUintN(32, r >> BigInt(32)));
  return { low: t, high: e };
}
function Jo(r) {
  var t = Ko(r);
  return vp(t);
}
function gp(r) {
  var t = Ko(r);
  return t.toString();
}
var mp = typeof BigInt != "undefined" ? gp : it;
function si(r) {
  return r;
}
function Zo(r) {
  if (r !== void 0)
    return ln(r);
}
var yp = {
  encodeHrTime: Jo,
  encodeSpanContext: ln,
  encodeOptionalSpanContext: Zo
};
function Qo(r) {
  var t, e;
  if (r === void 0)
    return yp;
  var n = (t = r.useLongBits) !== null && t !== void 0 ? t : !0, i = (e = r.useHex) !== null && e !== void 0 ? e : !1;
  return {
    encodeHrTime: n ? Jo : mp,
    encodeSpanContext: i ? si : ln,
    encodeOptionalSpanContext: i ? si : Zo
  };
}
var Ep = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ta(r) {
  return {
    attributes: At(r.attributes),
    droppedAttributesCount: 0
  };
}
function ea(r) {
  return {
    name: r.name,
    version: r.version
  };
}
function At(r) {
  return Object.keys(r).map(function(t) {
    return ra(t, r[t]);
  });
}
function ra(r, t) {
  return {
    key: r,
    value: na(t)
  };
}
function na(r) {
  var t = typeof r;
  return t === "string" ? { stringValue: r } : t === "number" ? Number.isInteger(r) ? { intValue: r } : { doubleValue: r } : t === "boolean" ? { boolValue: r } : r instanceof Uint8Array ? { bytesValue: r } : Array.isArray(r) ? { arrayValue: { values: r.map(na) } } : t === "object" && r != null ? {
    kvlistValue: {
      values: Object.entries(r).map(function(e) {
        var n = Ep(e, 2), i = n[0], o = n[1];
        return ra(i, o);
      })
    }
  } : {};
}
var q;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE";
})(q || (q = {}));
var Q;
(function(r) {
  r[r.HISTOGRAM = 0] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", r[r.GAUGE = 2] = "GAUGE", r[r.SUM = 3] = "SUM";
})(Q || (Q = {}));
var Tp = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), ui = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, ci = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Sp = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, bp = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, wp = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Op(r) {
  return r != null;
}
function ia(r) {
  var t = Object.keys(r);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(e) {
    return [e, r[e]];
  })));
}
function Ap(r) {
  var t, e;
  return r.name + ":" + ((t = r.version) !== null && t !== void 0 ? t : "") + ":" + ((e = r.schemaUrl) !== null && e !== void 0 ? e : "");
}
var oa = (
  /** @class */
  function(r) {
    Tp(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function se(r, t) {
  var e, n = new Promise(function(o, a) {
    e = setTimeout(function() {
      a(new oa("Operation timed out."));
    }, t);
  });
  return Promise.race([r, n]).then(function(i) {
    return clearTimeout(e), i;
  }, function(i) {
    throw clearTimeout(e), i;
  });
}
function Rp(r) {
  return ui(this, void 0, void 0, function() {
    var t = this;
    return ci(this, function(e) {
      return [2, Promise.all(r.map(function(n) {
        return ui(t, void 0, void 0, function() {
          var i, o;
          return ci(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function Lp(r) {
  return r.status === "rejected";
}
function li(r, t) {
  var e = [];
  return r.forEach(function(n) {
    e.push.apply(e, bp([], Sp(t(n)), !1));
  }), e;
}
function Pp(r, t) {
  var e, n;
  if (r.size !== t.size)
    return !1;
  try {
    for (var i = wp(r), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return !0;
}
function Np(r, t) {
  for (var e = 0, n = r.length - 1, i = r.length; n >= e; ) {
    var o = e + Math.trunc((n - e) / 2);
    r[o] < t ? e = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function Mp(r, t) {
  return r.toLowerCase() === t.toLowerCase();
}
var bt;
(function(r) {
  r[r.DROP = 0] = "DROP", r[r.SUM = 1] = "SUM", r[r.LAST_VALUE = 2] = "LAST_VALUE", r[r.HISTOGRAM = 3] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(bt || (bt = {}));
var Cp = (
  /** @class */
  function() {
    function r() {
      this.kind = bt.DROP;
    }
    return r.prototype.createAccumulation = function() {
    }, r.prototype.merge = function(t, e) {
    }, r.prototype.diff = function(t, e) {
    }, r.prototype.toMetricData = function(t, e, n, i) {
    }, r;
  }()
), T;
(function(r) {
  r.COUNTER = "COUNTER", r.GAUGE = "GAUGE", r.HISTOGRAM = "HISTOGRAM", r.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", r.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", r.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", r.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(T || (T = {}));
function st(r, t, e) {
  var n, i, o, a;
  return Up(r) || v.warn('Invalid metric name: "' + r + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: r,
    type: t,
    description: (n = e == null ? void 0 : e.description) !== null && n !== void 0 ? n : "",
    unit: (i = e == null ? void 0 : e.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = e == null ? void 0 : e.valueType) !== null && o !== void 0 ? o : dt.DOUBLE,
    advice: (a = e == null ? void 0 : e.advice) !== null && a !== void 0 ? a : {}
  };
}
function Ip(r, t) {
  var e, n;
  return {
    name: (e = r.name) !== null && e !== void 0 ? e : t.name,
    description: (n = r.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function xp(r, t) {
  return Mp(r.name, t.name) && r.unit === t.unit && r.type === t.type && r.valueType === t.valueType;
}
var Dp = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function Up(r) {
  return r.match(Dp) != null;
}
var kp = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Bp(r) {
  var t = r.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: r,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var br = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = Bp(e)), this.startTime = t, this._boundaries = e, this._recordMinMax = n, this._current = i;
    }
    return r.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var e = Np(this._boundaries, t);
        this._current.buckets.counts[e] += 1;
      }
    }, r.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), aa = (
  /** @class */
  function() {
    function r(t, e) {
      this._boundaries = t, this._recordMinMax = e, this.kind = bt.HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(t) {
      return new br(t, this._boundaries, this._recordMinMax);
    }, r.prototype.merge = function(t, e) {
      for (var n = t.toPointValue(), i = e.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new br(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, r.prototype.diff = function(t, e) {
      for (var n = t.toPointValue(), i = e.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new br(e.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, r.prototype.toMetricData = function(t, e, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: e,
        dataPointType: Q.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = kp(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, r;
  }()
), wr = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Or = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, fi = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      t === void 0 && (t = new Hp()), e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = e, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(r.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(e, n) {
        return t.at(n);
      });
    }, r.prototype.at = function(t) {
      var e = this.indexBase - this.indexStart;
      return t < e && (t += this.backing.length), t -= e, this.backing.countAt(t);
    }, r.prototype.incrementBucket = function(t, e) {
      this.backing.increment(t, e);
    }, r.prototype.decrementBucket = function(t, e) {
      this.backing.decrement(t, e);
    }, r.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, r.prototype.downscale = function(t) {
      this._rotate();
      for (var e = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < e; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, r.prototype.clone = function() {
      return new r(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, r.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, r.prototype._relocateBucket = function(t, e) {
      t !== e && this.incrementBucket(t, this.backing.emptyBucket(e));
    }, r;
  }()
), Hp = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(r.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.countAt = function(t) {
      return this._counts[t];
    }, r.prototype.growTo = function(t, e, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Or([
        n,
        this._counts.length - e
      ], wr(this._counts.slice(e)), !1)), i.splice.apply(i, Or([0, e], wr(this._counts.slice(0, e)), !1)), this._counts = i;
    }, r.prototype.reverse = function(t, e) {
      for (var n = Math.floor((t + e) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[e - i - 1], this._counts[e - i - 1] = o;
      }
    }, r.prototype.emptyBucket = function(t) {
      var e = this._counts[t];
      return this._counts[t] = 0, e;
    }, r.prototype.increment = function(t, e) {
      this._counts[t] += e;
    }, r.prototype.decrement = function(t, e) {
      this._counts[t] >= e ? this._counts[t] -= e : this._counts[t] = 0;
    }, r.prototype.clone = function() {
      return new r(Or([], wr(this._counts), !1));
    }, r;
  }()
), Gp = 52, jp = 2146435072, Vp = 1048575, _n = 1023, sa = -_n + 1, ua = _n, Kr = Math.pow(2, -1022);
function ca(r) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, r);
  var e = t.getUint32(0), n = (e & jp) >> 20;
  return n - _n;
}
function la(r) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, r);
  var e = t.getUint32(0), n = t.getUint32(4), i = (e & Vp) * Math.pow(2, 32);
  return i + n;
}
function Jr(r, t) {
  return r === 0 || r === Number.POSITIVE_INFINITY || r === Number.NEGATIVE_INFINITY || Number.isNaN(r) ? r : r * Math.pow(2, t);
}
function Fp(r) {
  return r--, r |= r >> 1, r |= r >> 2, r |= r >> 4, r |= r >> 8, r |= r >> 16, r++, r;
}
var $p = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), ue = (
  /** @class */
  function(r) {
    $p(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), Xp = (
  /** @class */
  function() {
    function r(t) {
      this._shift = -t;
    }
    return r.prototype.mapToIndex = function(t) {
      if (t < Kr)
        return this._minNormalLowerBoundaryIndex();
      var e = ca(t), n = this._rightShift(la(t) - 1, Gp);
      return e + n >> this._shift;
    }, r.prototype.lowerBoundary = function(t) {
      var e = this._minNormalLowerBoundaryIndex();
      if (t < e)
        throw new ue("underflow: " + t + " is < minimum lower boundary: " + e);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new ue("overflow: " + t + " is > maximum lower boundary: " + n);
      return Jr(1, t << this._shift);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      var t = sa >> this._shift;
      return this._shift < 2 && t--, t;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return ua >> this._shift;
    }, r.prototype._rightShift = function(t, e) {
      return Math.floor(t * Math.pow(2, -e));
    }, r;
  }()
), zp = (
  /** @class */
  function() {
    function r(t) {
      this._scale = t, this._scaleFactor = Jr(Math.LOG2E, t), this._inverseFactor = Jr(Math.LN2, -t);
    }
    return r.prototype.mapToIndex = function(t) {
      if (t <= Kr)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (la(t) === 0) {
        var e = ca(t);
        return (e << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, r.prototype.lowerBoundary = function(t) {
      var e = this._maxNormalLowerBoundaryIndex();
      if (t >= e) {
        if (t === e)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new ue("overflow: " + t + " is > maximum lower boundary: " + e);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Kr;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new ue("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      return sa << this._scale;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return (ua + 1 << this._scale) - 1;
    }, r;
  }()
), di = -10, pi = 20, qp = Array.from({ length: 31 }, function(r, t) {
  return t > 10 ? new zp(t - 10) : new Xp(t - 10);
});
function hi(r) {
  if (r > pi || r < di)
    throw new ue("expected scale >= " + di + " && <= " + pi + ", got: " + r);
  return qp[r + 10];
}
var Wp = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ee = (
  /** @class */
  function() {
    function r(t, e) {
      this.low = t, this.high = e;
    }
    return r.combine = function(t, e) {
      return new r(Math.min(t.low, e.low), Math.max(t.high, e.high));
    }, r;
  }()
), Yp = 20, Kp = 160, Ar = 2, Jp = (
  /** @class */
  function() {
    function r(t, e, n, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), e === void 0 && (e = Kp), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new fi()), l === void 0 && (l = new fi()), f === void 0 && (f = hi(Yp)), this.startTime = t, this._maxSize = e, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < Ar && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Ar), this._maxSize = Ar);
    }
    return r.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, r.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, r.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(r.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.updateByIncrement = function(t, e) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += e, t === 0) {
          this._zeroCount += e;
          return;
        }
        this._sum += t * e, t > 0 ? this._updateBuckets(this._positive, t, e) : this._updateBuckets(this._negative, -t, e);
      }
    }, r.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var e = this._minScale(t);
      this._downscale(this.scale - e), this._mergeBuckets(this.positive, t, t.positive, e), this._mergeBuckets(this.negative, t, t.negative, e);
    }, r.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var e = this._minScale(t);
      this._downscale(this.scale - e), this._diffBuckets(this.positive, t, t.positive, e), this._diffBuckets(this.negative, t, t.negative, e);
    }, r.prototype.clone = function() {
      return new r(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, r.prototype._updateBuckets = function(t, e, n) {
      var i = this._mapping.mapToIndex(e), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(e);
      }
      this._incrementIndexBy(t, i, n);
    }, r.prototype._incrementIndexBy = function(t, e, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = e), e < t.indexStart) {
          var i = t.indexEnd - e;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = e;
        } else if (e > t.indexEnd) {
          var i = e - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = e;
        }
        var o = e - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, r.prototype._grow = function(t, e) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = Fp(e);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, r.prototype._changeScale = function(t, e) {
      for (var n = 0; t - e >= this._maxSize; )
        t >>= 1, e >>= 1, n++;
      return n;
    }, r.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var e = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = hi(e);
      }
    }, r.prototype._minScale = function(t) {
      var e = Math.min(this.scale, t.scale), n = Ee.combine(this._highLowAtScale(this.positive, this.scale, e), this._highLowAtScale(t.positive, t.scale, e)), i = Ee.combine(this._highLowAtScale(this.negative, this.scale, e), this._highLowAtScale(t.negative, t.scale, e));
      return Math.min(e - this._changeScale(n.high, n.low), e - this._changeScale(i.high, i.low));
    }, r.prototype._highLowAtScale = function(t, e, n) {
      if (t.length === 0)
        return new Ee(0, -1);
      var i = e - n;
      return new Ee(t.indexStart >> i, t.indexEnd >> i);
    }, r.prototype._mergeBuckets = function(t, e, n, i) {
      for (var o = n.offset, a = e.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, r.prototype._diffBuckets = function(t, e, n, i) {
      for (var o = n.offset, a = e.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, r;
  }()
), Zp = (
  /** @class */
  function() {
    function r(t, e) {
      this._maxSize = t, this._recordMinMax = e, this.kind = bt.EXPONENTIAL_HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(t) {
      return new Jp(t, this._maxSize, this._recordMinMax);
    }, r.prototype.merge = function(t, e) {
      var n = e.clone();
      return n.merge(t), n;
    }, r.prototype.diff = function(t, e) {
      var n = e.clone();
      return n.diff(t), n;
    }, r.prototype.toMetricData = function(t, e, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: e,
        dataPointType: Q.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Wp(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === T.GAUGE || t.type === T.UP_DOWN_COUNTER || t.type === T.OBSERVABLE_GAUGE || t.type === T.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, r;
  }()
), Qp = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Rr = (
  /** @class */
  function() {
    function r(t, e, n) {
      e === void 0 && (e = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = e, this.sampleTime = n;
    }
    return r.prototype.record = function(t) {
      this._current = t, this.sampleTime = j(Date.now());
    }, r.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), th = (
  /** @class */
  function() {
    function r() {
      this.kind = bt.LAST_VALUE;
    }
    return r.prototype.createAccumulation = function(t) {
      return new Rr(t);
    }, r.prototype.merge = function(t, e) {
      var n = ve(e.sampleTime) >= ve(t.sampleTime) ? e : t;
      return new Rr(t.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.diff = function(t, e) {
      var n = ve(e.sampleTime) >= ve(t.sampleTime) ? e : t;
      return new Rr(e.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.toMetricData = function(t, e, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: e,
        dataPointType: Q.GAUGE,
        dataPoints: n.map(function(o) {
          var a = Qp(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, r;
  }()
), eh = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Kt = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = e, this._current = n, this.reset = i;
    }
    return r.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, r.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), _i = (
  /** @class */
  function() {
    function r(t) {
      this.monotonic = t, this.kind = bt.SUM;
    }
    return r.prototype.createAccumulation = function(t) {
      return new Kt(t, this.monotonic);
    }, r.prototype.merge = function(t, e) {
      var n = t.toPointValue(), i = e.toPointValue();
      return e.reset ? new Kt(e.startTime, this.monotonic, i, e.reset) : new Kt(t.startTime, this.monotonic, n + i);
    }, r.prototype.diff = function(t, e) {
      var n = t.toPointValue(), i = e.toPointValue();
      return this.monotonic && n > i ? new Kt(e.startTime, this.monotonic, i, !0) : new Kt(e.startTime, this.monotonic, i - n);
    }, r.prototype.toMetricData = function(t, e, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: e,
        dataPointType: Q.SUM,
        dataPoints: n.map(function(o) {
          var a = eh(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, r;
  }()
), Rt = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), at = (
  /** @class */
  function() {
    function r() {
    }
    return r.Drop = function() {
      return fa;
    }, r.Sum = function() {
      return da;
    }, r.LastValue = function() {
      return pa;
    }, r.Histogram = function() {
      return ha;
    }, r.ExponentialHistogram = function() {
      return ch;
    }, r.Default = function() {
      return lh;
    }, r;
  }()
), rh = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(e) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Cp(), t;
  }(at)
), nh = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(e) {
      switch (e.type) {
        case T.COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new _i(!0), t.NON_MONOTONIC_INSTANCE = new _i(!1), t;
  }(at)
), ih = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(e) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new th(), t;
  }(at)
), oh = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(e) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new aa([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(at)
), ah = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t(e, n) {
      n === void 0 && (n = !0);
      var i = r.call(this) || this;
      if (i._recordMinMax = n, e == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      e = e.concat(), e = e.sort(function(u, c) {
        return u - c;
      });
      var o = e.lastIndexOf(-1 / 0), a = e.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = e.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(e) {
      return new aa(this._boundaries, this._recordMinMax);
    }, t;
  }(at)
), sh = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t(e, n) {
      e === void 0 && (e = 160), n === void 0 && (n = !0);
      var i = r.call(this) || this;
      return i._maxSize = e, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(e) {
      return new Zp(this._maxSize, this._recordMinMax);
    }, t;
  }(at)
), uh = (
  /** @class */
  function(r) {
    Rt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(e) {
      switch (e.type) {
        case T.COUNTER:
        case T.UP_DOWN_COUNTER:
        case T.OBSERVABLE_COUNTER:
        case T.OBSERVABLE_UP_DOWN_COUNTER:
          return da;
        case T.GAUGE:
        case T.OBSERVABLE_GAUGE:
          return pa;
        case T.HISTOGRAM:
          return e.advice.explicitBucketBoundaries ? new ah(e.advice.explicitBucketBoundaries) : ha;
      }
      return v.warn("Unable to recognize instrument type: " + e.type), fa;
    }, t.prototype.createAggregator = function(e) {
      return this._resolve(e).createAggregator(e);
    }, t;
  }(at)
), fa = new rh(), da = new nh(), pa = new ih(), ha = new oh(), ch = new sh(), lh = new uh(), fh = function(r) {
  return at.Default();
}, dh = function(r) {
  return q.CUMULATIVE;
}, Lr = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, Pr = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, vi = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ph = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, hh = (
  /** @class */
  function() {
    function r(t) {
      var e, n, i;
      this._shutdown = !1, this._aggregationSelector = (e = t == null ? void 0 : t.aggregationSelector) !== null && e !== void 0 ? e : fh, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : dh, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return r.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, r.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, r.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, r.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, r.prototype.onInitialized = function() {
    }, r.prototype.collect = function(t) {
      return Lr(this, void 0, void 0, function() {
        var e, n, i, o, a, u;
        return Pr(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(ph([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], vi(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return e = vi.apply(void 0, [c.sent()]), n = e[0], i = e.slice(1), o = n.errors.concat(li(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(li(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, r.prototype.shutdown = function(t) {
      return Lr(this, void 0, void 0, function() {
        return Pr(this, function(e) {
          switch (e.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return e.sent(), [3, 4];
            case 2:
              return [4, se(this.onShutdown(), t.timeoutMillis)];
            case 3:
              e.sent(), e.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(t) {
      return Lr(this, void 0, void 0, function() {
        return Pr(this, function(e) {
          switch (e.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, se(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
), _h = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Te = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, Se = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, vh = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gh = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, mh = (
  /** @class */
  function(r) {
    _h(t, r);
    function t(e) {
      var n, i, o, a, u = r.call(this, {
        aggregationSelector: (n = e.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(e.exporter),
        aggregationTemporalitySelector: (i = e.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(e.exporter),
        metricProducers: e.metricProducers
      }) || this;
      if (e.exportIntervalMillis !== void 0 && e.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (e.exportTimeoutMillis !== void 0 && e.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (e.exportTimeoutMillis !== void 0 && e.exportIntervalMillis !== void 0 && e.exportIntervalMillis < e.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = e.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = e.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = e.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return Te(this, void 0, void 0, function() {
        var e;
        return Se(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, se(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return e = n.sent(), e instanceof oa ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (pt(e), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var e, n;
      return Te(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Se(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, gh(["PeriodicExportingMetricReader: metrics collection errors"], vh(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (e = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(e)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), v.debug("Error while resolving async portion of resource: ", u), pt(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, ml._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== M.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var e = this;
      this._interval = setInterval(function() {
        e._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return Te(this, void 0, void 0, function() {
        return Se(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return e.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return Te(this, void 0, void 0, function() {
        return Se(this, function(e) {
          switch (e.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return e.sent(), [4, this._exporter.shutdown()];
            case 2:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(hh)
), yh = (
  /** @class */
  function() {
    function r() {
      this._registeredViews = [];
    }
    return r.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, r.prototype.findViews = function(t, e) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, e);
      });
      return i;
    }, r.prototype._matchInstrument = function(t, e) {
      return (t.getType() === void 0 || e.type === t.getType()) && t.getNameFilter().match(e.name) && t.getUnitFilter().match(e.unit);
    }, r.prototype._matchMeter = function(t, e) {
      return t.getNameFilter().match(e.name) && (e.version === void 0 || t.getVersionFilter().match(e.version)) && (e.schemaUrl === void 0 || t.getSchemaUrlFilter().match(e.schemaUrl));
    }, r;
  }()
), Lt = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), qe = (
  /** @class */
  function() {
    function r(t, e) {
      this._writableMetricStorage = t, this._descriptor = e;
    }
    return r.prototype._record = function(t, e, n) {
      if (e === void 0 && (e = {}), n === void 0 && (n = S.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === dt.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, e, n, j(Date.now()));
    }, r;
  }()
), Eh = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.add = function(e, n, i) {
      this._record(e, n, i);
    }, t;
  }(qe)
), Th = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.add = function(e, n, i) {
      if (e < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + e);
        return;
      }
      this._record(e, n, i);
    }, t;
  }(qe)
), Sh = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.record = function(e, n, i) {
      this._record(e, n, i);
    }, t;
  }(qe)
), bh = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.record = function(e, n, i) {
      if (e < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + e);
        return;
      }
      this._record(e, n, i);
    }, t;
  }(qe)
), We = (
  /** @class */
  function() {
    function r(t, e, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = e;
    }
    return r.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, r.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, r;
  }()
), wh = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(We)
), Oh = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(We)
), Ah = (
  /** @class */
  function(r) {
    Lt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t;
  }(We)
);
function Zr(r) {
  return r instanceof We;
}
var Rh = (
  /** @class */
  function() {
    function r(t) {
      this._meterSharedState = t;
    }
    return r.prototype.createGauge = function(t, e) {
      var n = st(t, T.GAUGE, e), i = this._meterSharedState.registerMetricStorage(n);
      return new Sh(i, n);
    }, r.prototype.createHistogram = function(t, e) {
      var n = st(t, T.HISTOGRAM, e), i = this._meterSharedState.registerMetricStorage(n);
      return new bh(i, n);
    }, r.prototype.createCounter = function(t, e) {
      var n = st(t, T.COUNTER, e), i = this._meterSharedState.registerMetricStorage(n);
      return new Th(i, n);
    }, r.prototype.createUpDownCounter = function(t, e) {
      var n = st(t, T.UP_DOWN_COUNTER, e), i = this._meterSharedState.registerMetricStorage(n);
      return new Eh(i, n);
    }, r.prototype.createObservableGauge = function(t, e) {
      var n = st(t, T.OBSERVABLE_GAUGE, e), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Oh(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableCounter = function(t, e) {
      var n = st(t, T.OBSERVABLE_COUNTER, e), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new wh(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableUpDownCounter = function(t, e) {
      var n = st(t, T.OBSERVABLE_UP_DOWN_COUNTER, e), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Ah(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.addBatchObservableCallback = function(t, e) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, e);
    }, r.prototype.removeBatchObservableCallback = function(t, e) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, e);
    }, r;
  }()
), _a = (
  /** @class */
  function() {
    function r(t) {
      this._instrumentDescriptor = t;
    }
    return r.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, r.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = st(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, r;
  }()
), Lh = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), gi = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ph = (
  /** @class */
  function() {
    function r(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return r.prototype.get = function(t, e) {
      return e != null || (e = this._hash(t)), this._valueMap.get(e);
    }, r.prototype.getOrDefault = function(t, e) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = e();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, r.prototype.set = function(t, e, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, e);
    }, r.prototype.has = function(t, e) {
      return e != null || (e = this._hash(t)), this._valueMap.has(e);
    }, r.prototype.keys = function() {
      var t, e;
      return gi(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), e = t.next(), n.label = 1;
          case 1:
            return e.done === !0 ? [3, 3] : [4, [e.value[1], e.value[0]]];
          case 2:
            return n.sent(), e = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, r.prototype.entries = function() {
      var t, e;
      return gi(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), e = t.next(), n.label = 1;
          case 1:
            return e.done === !0 ? [3, 3] : [4, [this._keyMap.get(e.value[0]), e.value[1], e.value[0]]];
          case 2:
            return n.sent(), e = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(r.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Et = (
  /** @class */
  function(r) {
    Lh(t, r);
    function t() {
      return r.call(this, ia) || this;
    }
    return t;
  }(Ph)
), Nh = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, va = (
  /** @class */
  function() {
    function r(t, e) {
      this._aggregator = t, this._activeCollectionStorage = new Et(), this._cumulativeMemoStorage = new Et(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (e != null ? e : 2e3) - 1, this._overflowHashCode = ia(this._overflowAttributes);
    }
    return r.prototype.record = function(t, e, n, i) {
      var o = this, a = this._activeCollectionStorage.get(e);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(e, a);
      }
      a == null || a.record(t);
    }, r.prototype.batchCumulate = function(t, e) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = Nh(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(e);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, r.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Et(), t;
    }, r;
  }()
), Nr = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, mi = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ga = (
  /** @class */
  function() {
    function r(t, e) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), e.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return r.prototype.buildMetrics = function(t, e, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === q.CUMULATIVE ? a = r.merge(c.accumulations, o, this._aggregator) : a = r.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(e.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = Mh(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          e,
          u,
          l,
          /* endTime */
          i
        );
    }, r.prototype._stashAccumulations = function(t) {
      var e, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = Nr(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (e) throw e.error;
        }
      }
    }, r.prototype._getMergedUnreportedAccumulations = function(t) {
      var e, n, i = new Et(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = Nr(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = r.merge(i, c, this._aggregator);
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (e) throw e.error;
        }
      }
      return i;
    }, r.merge = function(t, e, n) {
      for (var i = t, o = e.entries(), a = o.next(); a.done !== !0; ) {
        var u = mi(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, r.calibrateStartTime = function(t, e, n) {
      var i, o;
      try {
        for (var a = Nr(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = mi(u.value, 2), s = c[0], l = c[1], f = e.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return e;
    }, r;
  }()
);
function Mh(r) {
  return Array.from(r.entries());
}
var Ch = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Ih = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, xh = (
  /** @class */
  function(r) {
    Ch(t, r);
    function t(e, n, i, o, a) {
      var u = r.call(this, e) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new va(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ga(n, o), u;
    }
    return t.prototype.record = function(e, n) {
      var i = this, o = new Et();
      Array.from(e.entries()).forEach(function(a) {
        var u = Ih(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(e, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(e, this._instrumentDescriptor, i, n);
    }, t;
  }(_a)
);
function yi(r, t) {
  var e = "";
  return r.unit !== t.unit && (e += "	- Unit '" + r.unit + "' does not match '" + t.unit + `'
`), r.type !== t.type && (e += "	- Type '" + r.type + "' does not match '" + t.type + `'
`), r.valueType !== t.valueType && (e += "	- Value Type '" + r.valueType + "' does not match '" + t.valueType + `'
`), r.description !== t.description && (e += "	- Description '" + r.description + "' does not match '" + t.description + `'
`), e;
}
function Dh(r, t) {
  return "	- use valueType '" + r.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function Uh(r, t) {
  return "	- use unit '" + r.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function kh(r, t) {
  var e = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(e);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + "'";
}
function Bh(r, t) {
  var e = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(e);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + r.name + " and description '" + r.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + r.description + "' and InstrumentSelector " + n;
}
function Ei(r, t) {
  return r.valueType !== t.valueType ? Dh(r, t) : r.unit !== t.unit ? Uh(r, t) : r.type !== t.type ? kh(r, t) : r.description !== t.description ? Bh(r, t) : "";
}
var Mr = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Hh = (
  /** @class */
  function() {
    function r() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return r.create = function() {
      return new r();
    }, r.prototype.getStorages = function(t) {
      var e, n, i, o, a = [];
      try {
        for (var u = Mr(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        e = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (e) throw e.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = Mr(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, r.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, r.prototype.registerForCollector = function(t, e) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(e, n);
    }, r.prototype.findOrUpdateCompatibleStorage = function(t) {
      var e = this._sharedRegistry.get(t.name);
      return e === void 0 ? null : this._findOrUpdateCompatibleStorage(t, e);
    }, r.prototype.findOrUpdateCompatibleCollectorStorage = function(t, e) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(e.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(e, i);
    }, r.prototype._registerStorage = function(t, e) {
      var n = t.getInstrumentDescriptor(), i = e.get(n.name);
      if (i === void 0) {
        e.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, r.prototype._findOrUpdateCompatibleStorage = function(t, e) {
      var n, i, o = null;
      try {
        for (var a = Mr(e), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          xp(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, yi(s, t), `The longer description will be used.
To resolve the conflict:`, Ei(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, yi(s, t), `To resolve the conflict:
`, Ei(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, r;
  }()
), Gh = (
  /** @class */
  function() {
    function r(t) {
      this._backingStorages = t;
    }
    return r.prototype.record = function(t, e, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, e, n, i);
      });
    }, r;
  }()
), jh = (
  /** @class */
  function() {
    function r(t, e) {
      this._instrumentName = t, this._valueType = e, this._buffer = new Et();
    }
    return r.prototype.observe = function(t, e) {
      if (e === void 0 && (e = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === dt.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(e, t);
    }, r;
  }()
), Vh = (
  /** @class */
  function() {
    function r() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return r.prototype.observe = function(t, e, n) {
      if (n === void 0 && (n = {}), !!Zr(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Et(), this._buffer.set(t, i)), typeof e != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + e);
          return;
        }
        t._descriptor.valueType === dt.INT && !Number.isInteger(e) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || i.set(n, e);
      }
    }, r;
  }()
), Cr = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, Ir = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ti = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Si = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, Fh = (
  /** @class */
  function() {
    function r() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return r.prototype.addCallback = function(t, e) {
      var n = this._findCallback(t, e);
      n >= 0 || this._callbacks.push({ callback: t, instrument: e });
    }, r.prototype.removeCallback = function(t, e) {
      var n = this._findCallback(t, e);
      n < 0 || this._callbacks.splice(n, 1);
    }, r.prototype.addBatchCallback = function(t, e) {
      var n = new Set(e.filter(Zr));
      if (n.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", e);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, r.prototype.removeBatchCallback = function(t, e) {
      var n = new Set(e.filter(Zr)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, r.prototype.observe = function(t, e) {
      return Cr(this, void 0, void 0, function() {
        var n, i, o, a;
        return Ir(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, e), i = this._observeBatchCallbacks(t, e), [4, Rp(Si(Si([], Ti(n), !1), Ti(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(Lp).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, r.prototype._observeCallbacks = function(t, e) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return Cr(n, void 0, void 0, function() {
          var u, c;
          return Ir(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new jh(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), e != null && (c = se(c, e)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._observeBatchCallbacks = function(t, e) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return Cr(n, void 0, void 0, function() {
          var u, c;
          return Ir(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new Vh(), c = Promise.resolve(o(u)), e != null && (c = se(c, e)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._findCallback = function(t, e) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === e;
      });
    }, r.prototype._findBatchCallback = function(t, e) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && Pp(n.instruments, e);
      });
    }, r;
  }()
), $h = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Xh = (
  /** @class */
  function(r) {
    $h(t, r);
    function t(e, n, i, o, a) {
      var u = r.call(this, e) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new va(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ga(n, o), u;
    }
    return t.prototype.record = function(e, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(e, n, i, o);
    }, t.prototype.collect = function(e, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(e, this._instrumentDescriptor, i, n);
    }, t;
  }(_a)
), ma = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), vn = (
  /** @class */
  function() {
    function r() {
    }
    return r.Noop = function() {
      return qh;
    }, r;
  }()
), zh = (
  /** @class */
  function(r) {
    ma(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.process = function(e, n) {
      return e;
    }, t;
  }(vn)
);
(function(r) {
  ma(t, r);
  function t(e) {
    var n = r.call(this) || this;
    return n._allowedAttributeNames = e, n;
  }
  return t.prototype.process = function(e, n) {
    var i = this, o = {};
    return Object.keys(e).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = e[a];
    }), o;
  }, t;
})(vn);
var qh = new zh(), Wh = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, Yh = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Kh = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Jh = (
  /** @class */
  function() {
    function r(t, e) {
      this._meterProviderSharedState = t, this._instrumentationScope = e, this.metricStorageRegistry = new Hh(), this.observableRegistry = new Fh(), this.meter = new Rh(this);
    }
    return r.prototype.registerMetricStorage = function(t) {
      var e = this._registerMetricStorage(t, Xh);
      return e.length === 1 ? e[0] : new Gh(e);
    }, r.prototype.registerAsyncMetricStorage = function(t) {
      var e = this._registerMetricStorage(t, xh);
      return e;
    }, r.prototype.collect = function(t, e, n) {
      return Wh(this, void 0, void 0, function() {
        var i, o, a;
        return Yh(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(e, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, e);
              }).filter(Op), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, r.prototype._registerMetricStorage = function(t, e) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Ip(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new e(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = Kh(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var h = f.createAggregator(t), _ = l.selectCardinalityLimit(t.type), p = new e(t, h, vn.Noop(), [l], _);
          return n.metricStorageRegistry.registerForCollector(l, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, r;
  }()
), Zh = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qh = (
  /** @class */
  function() {
    function r(t) {
      this.resource = t, this.viewRegistry = new yh(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return r.prototype.getMeterSharedState = function(t) {
      var e = Ap(t), n = this.meterSharedStates.get(e);
      return n == null && (n = new Jh(this, t), this.meterSharedStates.set(e, n)), n;
    }, r.prototype.selectAggregations = function(t) {
      var e, n, i = [];
      try {
        for (var o = Zh(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        e = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (e) throw e.error;
        }
      }
      return i;
    }, r;
  }()
), be = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, we = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, t_ = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, e_ = function(r, t, e) {
  if (e || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return r.concat(o || Array.prototype.slice.call(t));
}, r_ = (
  /** @class */
  function() {
    function r(t, e) {
      this._sharedState = t, this._metricReader = e;
    }
    return r.prototype.collect = function(t) {
      return be(this, void 0, void 0, function() {
        var e, n, i, o, a = this;
        return we(this, function(u) {
          switch (u.label) {
            case 0:
              return e = j(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return be(a, void 0, void 0, function() {
                  var s;
                  return we(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, e, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, e_([], t_(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, r.prototype.forceFlush = function(t) {
      return be(this, void 0, void 0, function() {
        return we(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.shutdown = function(t) {
      return be(this, void 0, void 0, function() {
        return we(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, r.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, r.prototype.selectCardinalityLimit = function(t) {
      var e, n, i;
      return (i = (n = (e = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(e, t)) !== null && i !== void 0 ? i : 2e3;
    }, r;
  }()
), bi = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, wi = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Oi = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function n_(r, t) {
  var e = t != null ? t : ae.empty();
  return r ? ae.default().merge(e) : e;
}
var i_ = (
  /** @class */
  function() {
    function r(t) {
      var e, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new Qh(n_((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = Oi(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          e = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (e) throw e.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = Oi(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return r.prototype.getMeter = function(t, e, n) {
      return e === void 0 && (e = ""), n === void 0 && (n = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), hu()) : this._sharedState.getMeterSharedState({
        name: t,
        version: e,
        schemaUrl: n.schemaUrl
      }).meter;
    }, r.prototype.addMetricReader = function(t) {
      var e = new r_(this._sharedState, t);
      t.setMetricProducer(e), this._sharedState.metricCollectors.push(e);
    }, r.prototype.shutdown = function(t) {
      return bi(this, void 0, void 0, function() {
        return wi(this, function(e) {
          switch (e.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(t) {
      return bi(this, void 0, void 0, function() {
        return wi(this, function(e) {
          switch (e.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function o_(r, t) {
  var e = Qo(t);
  return {
    resource: ta(r.resource),
    schemaUrl: void 0,
    scopeMetrics: a_(r.scopeMetrics, e)
  };
}
function a_(r, t) {
  return Array.from(r.map(function(e) {
    return {
      scope: ea(e.scope),
      metrics: e.metrics.map(function(n) {
        return s_(n, t);
      }),
      schemaUrl: e.scope.schemaUrl
    };
  }));
}
function s_(r, t) {
  var e = {
    name: r.descriptor.name,
    description: r.descriptor.description,
    unit: r.descriptor.unit
  }, n = f_(r.aggregationTemporality);
  switch (r.dataPointType) {
    case Q.SUM:
      e.sum = {
        aggregationTemporality: n,
        isMonotonic: r.isMonotonic,
        dataPoints: Ai(r, t)
      };
      break;
    case Q.GAUGE:
      e.gauge = {
        dataPoints: Ai(r, t)
      };
      break;
    case Q.HISTOGRAM:
      e.histogram = {
        aggregationTemporality: n,
        dataPoints: c_(r, t)
      };
      break;
    case Q.EXPONENTIAL_HISTOGRAM:
      e.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: l_(r, t)
      };
      break;
  }
  return e;
}
function u_(r, t, e) {
  var n = {
    attributes: At(r.attributes),
    startTimeUnixNano: e.encodeHrTime(r.startTime),
    timeUnixNano: e.encodeHrTime(r.endTime)
  };
  switch (t) {
    case dt.INT:
      n.asInt = r.value;
      break;
    case dt.DOUBLE:
      n.asDouble = r.value;
      break;
  }
  return n;
}
function Ai(r, t) {
  return r.dataPoints.map(function(e) {
    return u_(e, r.descriptor.valueType, t);
  });
}
function c_(r, t) {
  return r.dataPoints.map(function(e) {
    var n = e.value;
    return {
      attributes: At(e.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(e.startTime),
      timeUnixNano: t.encodeHrTime(e.endTime)
    };
  });
}
function l_(r, t) {
  return r.dataPoints.map(function(e) {
    var n = e.value;
    return {
      attributes: At(e.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(e.startTime),
      timeUnixNano: t.encodeHrTime(e.endTime)
    };
  });
}
function f_(r) {
  switch (r) {
    case q.DELTA:
      return 1;
    case q.CUMULATIVE:
      return 2;
  }
}
function d_(r, t) {
  return {
    resourceMetrics: r.map(function(e) {
      return o_(e, t);
    })
  };
}
var p_ = function(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e) return e.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, h_ = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function __(r, t) {
  var e, n = r.spanContext(), i = r.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(r.parentSpanId),
    traceState: (e = n.traceState) === null || e === void 0 ? void 0 : e.serialize(),
    name: r.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: r.kind == null ? 0 : r.kind + 1,
    startTimeUnixNano: t.encodeHrTime(r.startTime),
    endTimeUnixNano: t.encodeHrTime(r.endTime),
    attributes: At(r.attributes),
    droppedAttributesCount: r.droppedAttributesCount,
    events: r.events.map(function(o) {
      return g_(o, t);
    }),
    droppedEventsCount: r.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: r.links.map(function(o) {
      return v_(o, t);
    }),
    droppedLinksCount: r.droppedLinksCount
  };
}
function v_(r, t) {
  var e;
  return {
    attributes: r.attributes ? At(r.attributes) : [],
    spanId: t.encodeSpanContext(r.context.spanId),
    traceId: t.encodeSpanContext(r.context.traceId),
    traceState: (e = r.context.traceState) === null || e === void 0 ? void 0 : e.serialize(),
    droppedAttributesCount: r.droppedAttributesCount || 0
  };
}
function g_(r, t) {
  return {
    attributes: r.attributes ? At(r.attributes) : [],
    name: r.name,
    timeUnixNano: t.encodeHrTime(r.time),
    droppedAttributesCount: r.droppedAttributesCount || 0
  };
}
function m_(r, t) {
  var e = Qo(t);
  return {
    resourceSpans: E_(r, e)
  };
}
function y_(r) {
  var t, e, n = /* @__PURE__ */ new Map();
  try {
    for (var i = p_(r), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function E_(r, t) {
  for (var e = y_(r), n = [], i = e.entries(), o = i.next(); !o.done; ) {
    for (var a = h_(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return __(p, t);
        });
        s.push({
          scope: ea(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: ta(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var T_ = {
  serializeRequest: function(r) {
    var t = d_([r], {
      useLongBits: !1
    }), e = new TextEncoder();
    return e.encode(JSON.stringify(t));
  },
  deserializeResponse: function(r) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(r));
  }
}, S_ = {
  serializeRequest: function(r) {
    var t = m_(r, {
      useHex: !0,
      useLongBits: !1
    }), e = new TextEncoder();
    return e.encode(JSON.stringify(t));
  },
  deserializeResponse: function(r) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(r));
  }
}, b_ = function(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(r, t || [])).next());
  });
}, w_ = function(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return e.label++, { value: s[1], done: !1 };
        case 5:
          e.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            e = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            e.label = s[1];
            break;
          }
          if (s[0] === 6 && e.label < o[1]) {
            e.label = o[1], o = s;
            break;
          }
          if (o && e.label < o[2]) {
            e.label = o[2], e.ops.push(s);
            break;
          }
          o[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      s = t.call(r, e);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, O_ = 5, A_ = 1e3, R_ = 5e3, L_ = 1.5, Ri = 0.2;
function P_() {
  return Math.random() * (2 * Ri) - Ri;
}
var N_ = (
  /** @class */
  function() {
    function r(t) {
      this._transport = t;
    }
    return r.prototype.retry = function(t, e, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, e).then(o, a);
        }, n);
      });
    }, r.prototype.send = function(t, e) {
      var n;
      return b_(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return w_(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + e, [4, this._transport.send(t, e)];
            case 1:
              o = f.sent(), a = O_, u = A_, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, R_) + P_(), 0), u = u * L_, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, r.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, r;
  }()
);
function ya(r) {
  return new N_(r.transport);
}
function M_(r) {
  var t = [429, 502, 503, 504];
  return t.includes(r);
}
function C_(r) {
  if (r != null) {
    var t = Number.parseInt(r, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var e = new Date(r).getTime() - Date.now();
    return e >= 0 ? e : 0;
  }
}
var I_ = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, x_ = (
  /** @class */
  function() {
    function r(t) {
      this._parameters = t;
    }
    return r.prototype.send = function(t, e) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = e, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = I_(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && M_(o.status) ? i({
            status: "retryable",
            retryInMillis: C_(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, r.prototype.shutdown = function() {
    }, r;
  }()
);
function D_(r) {
  return new x_(r);
}
var U_ = (
  /** @class */
  function() {
    function r(t) {
      this._params = t;
    }
    return r.prototype.send = function(t) {
      var e = this;
      return new Promise(function(n) {
        navigator.sendBeacon(e._params.url, new Blob([t], { type: e._params.blobType })) ? (v.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, r.prototype.shutdown = function() {
    }, r;
  }()
);
function k_(r) {
  return new U_(r);
}
function B_(r, t) {
  return Yo(r, t, ya({
    transport: D_(r)
  }));
}
function H_(r, t) {
  return Yo(r, t, ya({
    transport: k_({
      url: r.url,
      blobType: r.headers()["Content-Type"]
    })
  }));
}
var G_ = function(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e) return r;
  var n = e.call(r), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function j_(r) {
  return function() {
    var t, e = {};
    return Object.entries((t = r == null ? void 0 : r()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = G_(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? e[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), e;
  };
}
var wt = function() {
  return wt = Object.assign || function(r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, wt.apply(this, arguments);
};
function V_(r, t, e) {
  var n = wt({}, e()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), r != null && Object.assign(i, r()), Object.assign(i, n);
  };
}
function F_(r) {
  if (r != null)
    try {
      return new URL(r), r;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + r + "'");
    }
}
function $_(r, t, e) {
  var n, i, o, a;
  return wt(wt({}, ip(r, t, e)), { headers: V_(j_(r.headers), t.headers, e.headers), url: (i = (n = F_(r.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : e.url, agentOptions: (a = (o = r.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : e.agentOptions });
}
function X_(r, t) {
  return wt(wt({}, op()), { headers: function() {
    return r;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function z_(r, t, e) {
  return $_(
    {
      url: r.url,
      timeoutMillis: r.timeoutMillis,
      headers: np(r.headers),
      concurrencyLimit: r.concurrencyLimit
    },
    {},
    // no fallback for browser case
    X_(e, t)
  );
}
function Ea(r, t, e, n) {
  var i = !!r.headers || typeof navigator.sendBeacon != "function", o = z_(r, e, n);
  return i ? B_(o, t) : H_(o, t);
}
var q_ = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), W_ = (
  /** @class */
  function(r) {
    q_(t, r);
    function t(e) {
      return e === void 0 && (e = {}), r.call(this, Ea(e, S_, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(Wo)
), He;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE", r[r.LOWMEMORY = 2] = "LOWMEMORY";
})(He || (He = {}));
var Y_ = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), Qr = function() {
  return q.CUMULATIVE;
}, Ta = function(r) {
  switch (r) {
    case T.COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.GAUGE:
    case T.HISTOGRAM:
    case T.OBSERVABLE_GAUGE:
      return q.DELTA;
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
      return q.CUMULATIVE;
  }
}, Sa = function(r) {
  switch (r) {
    case T.COUNTER:
    case T.HISTOGRAM:
      return q.DELTA;
    case T.GAUGE:
    case T.UP_DOWN_COUNTER:
    case T.OBSERVABLE_UP_DOWN_COUNTER:
    case T.OBSERVABLE_COUNTER:
    case T.OBSERVABLE_GAUGE:
      return q.CUMULATIVE;
  }
};
function K_() {
  var r = Gt(), t = r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Qr : t === "delta" ? Ta : t === "lowmemory" ? Sa : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Qr);
}
function J_(r) {
  return r != null ? r === He.DELTA ? Ta : r === He.LOWMEMORY ? Sa : Qr : K_();
}
function Z_(r) {
  return r != null && r.aggregationPreference ? r.aggregationPreference : function(t) {
    return at.Default();
  };
}
var Q_ = (
  /** @class */
  function(r) {
    Y_(t, r);
    function t(e, n) {
      var i = r.call(this, e) || this;
      return i._aggregationSelector = Z_(n), i._aggregationTemporalitySelector = J_(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(e) {
      return this._aggregationSelector(e);
    }, t.prototype.selectAggregationTemporality = function(e) {
      return this._aggregationTemporalitySelector(e);
    }, t;
  }(Wo)
), tv = /* @__PURE__ */ function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function n() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), ev = (
  /** @class */
  function(r) {
    tv(t, r);
    function t(e) {
      return r.call(this, Ea(e != null ? e : {}, T_, "v1/metrics", { "Content-Type": "application/json" }), e) || this;
    }
    return t;
  }(Q_)
);
function rv(r, t) {
  const e = r.spanContext();
  return {
    name: r.name,
    kind: r.kind,
    spanContext: () => e,
    parentSpanId: r.parentSpanId,
    startTime: r.startTime,
    endTime: r.endTime,
    status: r.status,
    attributes: Oo(r.attributes, t),
    links: r.links,
    events: r.events,
    duration: r.duration,
    ended: r.ended,
    resource: r.resource,
    instrumentationLibrary: r.instrumentationLibrary,
    droppedAttributesCount: r.droppedAttributesCount,
    droppedEventsCount: r.droppedEventsCount,
    droppedLinksCount: r.droppedLinksCount
  };
}
function nv(r, t) {
  if (!t.isSamplingEnabled())
    return r;
  const e = [], n = {}, i = {};
  for (const o of r) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = rv(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : e.push(o.spanContext().spanId);
  }
  for (; e.length > 0; ) {
    const o = e.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], e.push(u);
  }
  return Object.values(n);
}
class iv extends W_ {
  constructor(t, e) {
    super(P(b({}, t), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    })), this.sampler = e;
  }
  export(t, e) {
    const n = nv(t, this.sampler);
    if (n.length === 0)
      return;
    let i = 0;
    const o = (a) => {
      var u;
      if (a.code === M.SUCCESS)
        return e({
          code: M.SUCCESS
        });
      if (i++, i > Yi)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL traces: ${(u = a.error) == null ? void 0 : u.message}`,
          a.error
        ), e({
          code: M.FAILED,
          error: a.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          Ki + Ji * Math.pow(2, i)
        )
      ).then(() => {
        var c;
        console.warn(
          `[@launchdarkly/observability] retry ${i}, failed to export OTeL traces: ${(c = a.error) == null ? void 0 : c.message}`,
          a.error
        ), super.export(n, o);
      });
    };
    super.export(n, o);
  }
}
class ov extends ev {
  constructor(t) {
    super(P(b({}, t), {
      headers: {}
    }));
  }
  export(t, e) {
    let n = 0;
    const i = (o) => {
      var a;
      if (o.code === M.SUCCESS)
        return e({
          code: M.SUCCESS
        });
      if (n++, n > Yi)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(a = o.error) == null ? void 0 : a.message}`,
          o.error
        ), e({
          code: M.FAILED,
          error: o.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          Ki + Ji * Math.pow(2, n)
        )
      ).then(() => {
        var u;
        console.warn(
          `[@launchdarkly/observability] retry ${n}, failed to export OTeL metrics: ${(u = o.error) == null ? void 0 : u.message}`,
          o.error
        ), super.export(t, i);
      });
    };
    super.export(t, i);
  }
}
const av = "OT_ZONE_CONTEXT", sv = "Navigation:", uv = ["click", "input", "submit"];
function cv() {
  return !1;
}
const Y = class Y extends Cl {
  constructor(e = {}) {
    var n;
    super(
      Y.moduleName,
      Y.version,
      e
    );
    A(this, "_spansData", /* @__PURE__ */ new WeakMap());
    A(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    A(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    A(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    A(this, "_eventNames");
    A(this, "_shouldPreventSpanCreation");
    this._eventNames = new Set(
      (n = e == null ? void 0 : e.eventNames) != null ? n : uv
    ), this._shouldPreventSpanCreation = typeof (e == null ? void 0 : e.shouldPreventSpanCreation) == "function" ? e.shouldPreventSpanCreation : cv;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(e, n) {
    const i = this._spansData.get(n);
    i && (e.source === "setTimeout" ? i.hrTimeLastTimeout = St() : e.source !== "Promise.then" && e.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(e) {
    return this._eventNames.has(e);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(e, n) {
    var u;
    const i = e == null ? void 0 : e.target, o = e == null ? void 0 : e.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Go(i, !0);
    try {
      const c = this.tracer.startSpan(
        o,
        {
          attributes: {
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? O.setSpan(S.active(), n) : void 0
      );
      return e instanceof MouseEvent && (c.setAttribute("event.x", e.clientX), c.setAttribute("event.y", e.clientY), c.setAttribute(
        "event.relativeX",
        e.clientX / window.innerWidth
      ), c.setAttribute(
        "event.relativeY",
        e.clientY / window.innerHeight
      ), o === "scroll" && (c.setAttribute("event.scrollX", window.scrollX), c.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, c) === !0 ? void 0 : (this._spansData.set(c, {
        taskCount: 0
      }), c);
    } catch (c) {
      this._diag.error(
        "failed to start create new user interaction span",
        c
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(e) {
    const n = this._spansData.get(e);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(e, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(e) {
    const n = e.get(av);
    return n && O.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(e) {
    const n = this._spansData.get(e);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(e, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(e) ? !1 : (u.set(e, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(e, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(e);
    return u && (a.delete(e), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(e, n, i) {
    return typeof e == "function" ? e.apply(n, i) : e.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const e = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var p;
        let d;
        const h = f[0];
        if (!(h != null && h.type))
          return e._invokeListener(u, this, f);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return e._invokeListener(u, this, f);
        n.set(h.type, Date.now()), h && (d = e._eventsSpanMap.get(h)), s && e.removePatchedListener(this, a, u);
        const _ = e._createSpan(h, d);
        return _ ? (h && e._eventsSpanMap.set(h, _), S.with(
          O.setSpan(S.active(), _),
          () => {
            const g = e._invokeListener(
              u,
              this,
              f
            );
            return _.end(), g;
          }
        )) : e._invokeListener(u, this, f);
      };
      if (e.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const e = this;
    return (n) => function(o, a, u) {
      const c = e.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const e = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && e._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    I(history.replaceState) && this._unwrap(history, "replaceState"), I(history.pushState) && this._unwrap(history, "pushState"), I(history.back) && this._unwrap(history, "back"), I(history.forward) && this._unwrap(history, "forward"), I(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(e) {
    const n = O.getSpan(
      S.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${sv} ${e}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const e = this;
    return (n) => function(o) {
      const a = Zone.current, u = e._getCurrentSpan(a);
      return u && e._shouldCountTask(o, a) && e._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const e = this;
    return (n) => function(o) {
      const a = Zone.current, u = e._getCurrentSpan(a);
      return u && e._shouldCountTask(o, a) && (e._incrementTask(u), e._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const e = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = e._createSpan(c), l)
          return e._incrementTask(l), f.run(() => {
            try {
              return S.with(
                O.setSpan(
                  S.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              e._decrementTask(l);
            }
          });
      } else
        l = e._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && e._shouldCountTask(o, f) && e._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(e, n) {
    if (e._zone && (n = e._zone), !n || !e.data || e.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : e.type === "macroTask" || e.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(e, n) {
    e && this._spansData.get(e) && (e.end(n), this._spansData.delete(e));
  }
  /**
   * implements enable function
   */
  enable() {
    const e = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      Y.moduleName,
      Y.version,
      "zone:",
      !!e
    ), e ? (I(e.prototype.runTask) && (this._unwrap(e.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), I(e.prototype.scheduleTask) && (this._unwrap(e.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), I(e.prototype.cancelTask) && (this._unwrap(e.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      e.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      e.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      e.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      I(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), I(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const e = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      Y.moduleName,
      Y.version,
      "zone:",
      !!e
    ), e && this._zonePatched ? (I(e.prototype.runTask) && this._unwrap(e.prototype, "runTask"), I(e.prototype.scheduleTask) && this._unwrap(e.prototype, "scheduleTask"), I(e.prototype.cancelTask) && this._unwrap(e.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      I(i.addEventListener) && this._unwrap(i, "addEventListener"), I(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
A(Y, "version", "0.1.0"), A(Y, "moduleName", "user-interaction");
let tn = Y, k = {}, et;
const Ge = "highlight.record", lv = "highlight.session_id", ba = "launchdarkly.js.log", fv = "launchdarkly.exception.id", Li = "launchdarkly.sampling.ratio", wa = "log.severity", Oa = "log.message", dv = (r, t) => {
  var p, g, m, y, w, L, B, D, Nt;
  if (k.tracerProvider !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  et = r;
  const e = r.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(g = (p = r.networkRecordingOptions) == null ? void 0 : p.urlBlocklist) != null ? g : [],
    ...Fd
  ], i = (m = r.environment) != null ? m : "production", o = {
    url: r.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 100,
    timeoutMillis: 5e3,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 5e3,
      keepAlive: !0
    }
  }, a = new iv(
    o,
    t
  ), u = new pv(a, {
    maxExportBatchSize: 100,
    maxQueueSize: 1e3,
    exportTimeoutMillis: o.timeoutMillis,
    scheduledDelayMillis: o.timeoutMillis
  }), c = new ae({
    [Fa]: (y = r.serviceName) != null ? y : "highlight-browser",
    "deployment.environment.name": i,
    "highlight.project_id": r.projectId,
    [Va]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": ja
  });
  k.tracerProvider = new gf({
    resource: c,
    mergeResourceWithDefaults: !0,
    spanProcessors: [u]
  }), O.setGlobalTracerProvider(k.tracerProvider);
  const s = new ov(P(b({}, o), {
    url: r.otlpEndpoint + "/v1/metrics"
  })), l = new mh({
    exporter: s,
    exportIntervalMillis: o.timeoutMillis,
    exportTimeoutMillis: o.timeoutMillis
  });
  k.meterProvider = new i_({ resource: c, readers: [l] }), Z.setGlobalMeterProvider(k.meterProvider);
  let f = [];
  ((w = r.instrumentations) == null ? void 0 : w["@opentelemetry/instrumentation-document-load"]) !== !1 && f.push(
    new Df({
      applyCustomAttributesOnSpan: {
        documentLoad: Ci,
        documentFetch: Ci,
        resourceFetch: gv
      }
    })
  ), ((L = r.instrumentations) == null ? void 0 : L["@opentelemetry/instrumentation-user-interaction"]) !== !1 && f.push(
    new tn({
      eventNames: r.eventNames
    })
  ), (B = r.networkRecordingOptions) != null && B.enabled && (((D = r.instrumentations) == null ? void 0 : D["@opentelemetry/instrumentation-fetch"]) !== !1 && f.push(
    new hd({
      propagateTraceHeaderCorsUrls: Ii(
        r.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (U, _t, X) => z(void 0, null, function* () {
        var Xt, Tn, Sn;
        if (!U.attributes)
          return;
        const Je = U;
        if (Je.attributes[Ge] === !1)
          return;
        const Ze = Je.attributes["http.url"], Qe = (Xt = _t.method) != null ? Xt : "GET";
        if (U.updateName(Ni(Ze, Qe, _t.body)), !(X instanceof Response)) {
          U.setAttributes({
            "http.response.error": X.message,
            "http.response.status": X.status
          });
          return;
        }
        Mi(
          U,
          _t.body,
          _t.headers,
          r.networkRecordingOptions
        );
        const he = yield qo(
          X,
          (Tn = r.networkRecordingOptions) == null ? void 0 : Tn.bodyKeysToRecord,
          (Sn = r.networkRecordingOptions) == null ? void 0 : Sn.networkBodyKeysToRedact
        );
        U.setAttribute("http.response.body", he);
      })
    })
  ), ((Nt = r.instrumentations) == null ? void 0 : Nt["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && f.push(
    new jd({
      propagateTraceHeaderCorsUrls: Ii(
        r.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (U, _t) => {
        var he, Xt;
        const X = _t;
        if (!U.attributes || U.attributes[Ge] === !1)
          return;
        const Ze = Ni(
          X._url,
          X._method,
          _t.responseText
        );
        U.updateName(Ze), Mi(
          U,
          X._body,
          X._requestHeaders,
          r.networkRecordingOptions
        );
        const Qe = lt(
          X._body,
          (he = r.networkRecordingOptions) == null ? void 0 : he.networkBodyKeysToRedact,
          (Xt = r.networkRecordingOptions) == null ? void 0 : Xt.bodyKeysToRecord,
          X._requestHeaders
        );
        U.setAttribute("http.request.body", Qe);
      }
    })
  )), Rl({ instrumentations: f });
  const _ = new ko();
  return _.enable(), k.tracerProvider.register({
    contextManager: _,
    propagator: new yo({
      propagators: [
        new fo(),
        new hv({
          backendUrl: e,
          otlpEndpoint: r.otlpEndpoint,
          tracingOrigins: r.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), k;
};
class pv extends Uo {
  onStart(t, e) {
    t.setAttribute(lv, ut()), super.onStart(t, e);
  }
  onEnd(t) {
    t.attributes[Ge] !== !1 && super.onEnd(t);
  }
}
class hv extends Eo {
  constructor(e) {
    super();
    A(this, "highlightEndpoints");
    A(this, "tracingOrigins");
    A(this, "urlBlocklist");
    this.highlightEndpoints = [
      e.backendUrl,
      `${e.otlpEndpoint}/v1/traces`,
      `${e.otlpEndpoint}/v1/logs`,
      `${e.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = e.tracingOrigins, this.urlBlocklist = e.urlBlocklist;
  }
  inject(e, n, i) {
    var u;
    const o = O.getSpan(e);
    if (!o || !o.attributes)
      return;
    const a = o.attributes["http.url"];
    typeof a == "string" && (vv(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(Ge, !1), !hn(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(e, n, i);
  }
}
const Aa = "highlight-browser", Oe = Aa, Pi = () => {
  var r;
  return (r = k.tracerProvider) == null ? void 0 : r.getTracer(Aa);
}, _v = () => O.getActiveSpan(), eg = () => z(void 0, null, function* () {
  k.tracerProvider ? (yield k.tracerProvider.forceFlush(), yield k.tracerProvider.shutdown()) : console.warn("OTEL shutdown called without initialized tracerProvider."), k.meterProvider ? (yield k.meterProvider.forceFlush(), yield k.meterProvider.shutdown()) : console.warn("OTEL shutdown called without initialized meterProvider.");
}), Ni = (r, t, e) => {
  var u, c, s;
  let n;
  const i = new URL(r), o = i.pathname;
  let a = `${t.toUpperCase()} - ${o}`;
  try {
    if (n = typeof e == "string" ? JSON.parse(e) : e, n && n.query) {
      const l = Xa(n.query), f = ((u = l.definitions[0]) == null ? void 0 : u.kind) === "OperationDefinition" ? (s = (c = l.definitions[0]) == null ? void 0 : c.name) == null ? void 0 : s.value : void 0;
      f && (a = `${f} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (l) {
  }
  return a;
}, Mi = (r, t, e, n) => {
  var l;
  const i = typeof t == "string" ? t : String(t);
  if (!r.attributes)
    return;
  const a = r.attributes["http.url"], u = new URL(a);
  let c;
  try {
    c = t ? JSON.parse(i) : void 0, c.operationName && r.setAttribute(
      "graphql.operation.name",
      c.operationName
    );
  } catch (f) {
  }
  const s = Fo(
    (l = n == null ? void 0 : n.networkHeadersToRedact) != null ? l : [],
    e,
    n == null ? void 0 : n.headerKeysToRecord
  );
  r.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(s),
    "http.request.body": i,
    [Wa]: a,
    [qa]: u.pathname,
    [za]: u.search
  }), u.searchParams.size > 0 && r.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(
      Object.fromEntries(u.searchParams)
    )
  });
}, vv = (r, t, e, n) => n != null && n.some(
  (o) => r.toLowerCase().includes(o)
) ? !1 : pn(
  r,
  t
), Ci = (r) => {
  var o, a, u;
  if (!r.events)
    return;
  const e = r.events, n = {
    unload: H("unloadEventStart", "unloadEventEnd", e),
    dom_interactive: H(
      "fetchStart",
      "domInteractive",
      e
    ),
    dom_content_loaded: H(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      e
    ),
    dom_complete: H("fetchStart", "domComplete", e),
    load_event: H("loadEventStart", "loadEventEnd", e),
    document_load: H("fetchStart", "loadEventEnd", e),
    first_paint: H("fetchStart", "firstPaint", e),
    first_contentful_paint: H(
      "fetchStart",
      "firstContentfulPaint",
      e
    ),
    domain_lookup: H(
      "domainLookupStart",
      "domainLookupEnd",
      e
    ),
    connect: H("connectStart", "connectEnd", e),
    request: H("requestStart", "requestEnd", e),
    response: H("responseStart", "responseEnd", e)
  }, i = (a = (o = et == null ? void 0 : et.getIntegrations) == null ? void 0 : o.call(et)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = et == null ? void 0 : et.sessionSecureId) != null ? u : "", {
        name: $a,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (r.setAttribute(`timings.${c}.ns`, s), r.setAttribute(
      `timings.${c}.readable`,
      Ra(s)
    ));
  });
};
function H(r, t, e) {
  const n = e.find((u) => u.name === r), i = e.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const gv = (r, t) => {
  const e = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(e).forEach(([n, i]) => {
    r.setAttribute(`timings.${n}.ns`, i), r.setAttribute(`timings.${n}.readable`, Ra(i));
  });
}, Ra = (r) => {
  if (r >= 36e11) {
    const a = r / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (r >= 6e10) {
    const a = r / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (r >= 1e9) {
    const a = r / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (r >= 1e6) {
    const a = r / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (r >= 1e3) {
    const a = r / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(r.toFixed(1))}ns`;
}, Ii = (r) => r === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(r) ? r.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, mv = 30, yv = () => new Promise(
  (r) => requestAnimationFrame(
    (t) => requestAnimationFrame((e) => r(e - t))
  )
), Ev = () => z(void 0, null, function* () {
  const r = [];
  for (let t = 0; t < mv; t++)
    r.push(yield yv());
  return r.reduce((t, e) => t + e, 0) / r.length;
}), Tv = (r, t) => {
  let e = {}, n = 16.666666666666668;
  Ev().then((c) => n = c);
  const i = (c) => {
    var s;
    e != null && e.event || (e = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(e != null && e.timerStart)) return;
    const c = window.performance.now() - e.timerStart - n;
    a(c), e = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    r({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != e.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = e == null ? void 0 : e.event) != null && c.target ? Ya(e.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, Sv = typeof window != "undefined", xi = Sv && "performance" in window && "memory" in performance ? performance : { memory: {} }, bv = (r, t) => {
  let e = 0, n = 0;
  const i = () => {
    const l = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, f = xi.memory.jsHeapSizeLimit || 0, d = xi.memory.usedJSHeapSize || 0;
    r({
      jsHeapSizeLimit: f,
      usedJSHeapSize: d,
      relativeTimestamp: l,
      fps: e
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (e = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var ft, re, La, je, en, Pa = -1, Pt = function(r) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Pa = t.timeStamp, r(t));
  }, !0);
}, gn = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Ye = function() {
  var r = gn();
  return r && r.activationStart || 0;
}, F = function(r, t) {
  var e = gn(), n = "navigate";
  return Pa >= 0 ? n = "back-forward-cache" : e && (document.prerendering || Ye() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : e.type && (n = e.type.replace(/_/g, "-"))), { name: r, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Ft = function(r, t, e) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(r)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: r, buffered: !0 }, e || {})), n;
    }
  } catch (i) {
  }
}, $ = function(r, t, e, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, e), r(t));
  };
}, mn = function(r) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return r();
    });
  });
}, Ke = function(r) {
  var t = function(e) {
    e.type !== "pagehide" && document.visibilityState !== "hidden" || r(e);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, yn = function(r) {
  var t = !1;
  return function(e) {
    t || (r(e), t = !0);
  };
}, kt = -1, Di = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Ve = function(r) {
  document.visibilityState === "hidden" && kt > -1 && (kt = r.type === "visibilitychange" ? r.timeStamp : 0, wv());
}, Ui = function() {
  addEventListener("visibilitychange", Ve, !0), addEventListener("prerenderingchange", Ve, !0);
}, wv = function() {
  removeEventListener("visibilitychange", Ve, !0), removeEventListener("prerenderingchange", Ve, !0);
}, En = function() {
  return kt < 0 && (kt = Di(), Ui(), Pt(function() {
    setTimeout(function() {
      kt = Di(), Ui();
    }, 0);
  })), { get firstHiddenTime() {
    return kt;
  } };
}, pe = function(r) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return r();
  }, !0) : r();
}, ki = [1800, 3e3], Na = function(r, t) {
  t = t || {}, pe(function() {
    var e, n = En(), i = F("FCP"), o = Ft("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Ye(), 0), i.entries.push(u), e(!0)));
      });
    });
    o && (e = $(r, i, ki, t.reportAllChanges), Pt(function(a) {
      i = F("FCP"), e = $(r, i, ki, t.reportAllChanges), mn(function() {
        i.value = performance.now() - a.timeStamp, e(!0);
      });
    }));
  });
}, Bi = [0.1, 0.25], Ov = function(r, t) {
  t = t || {}, Na(yn(function() {
    var e, n = F("CLS", 0), i = 0, o = [], a = function(c) {
      c.forEach(function(s) {
        if (!s.hadRecentInput) {
          var l = o[0], f = o[o.length - 1];
          i && s.startTime - f.startTime < 1e3 && s.startTime - l.startTime < 5e3 ? (i += s.value, o.push(s)) : (i = s.value, o = [s]);
        }
      }), i > n.value && (n.value = i, n.entries = o, e());
    }, u = Ft("layout-shift", a);
    u && (e = $(r, n, Bi, t.reportAllChanges), Ke(function() {
      a(u.takeRecords()), e(!0);
    }), Pt(function() {
      i = 0, n = F("CLS", 0), e = $(r, n, Bi, t.reportAllChanges), mn(function() {
        return e();
      });
    }), setTimeout(e, 0));
  }));
}, Jt = { passive: !0, capture: !0 }, Av = /* @__PURE__ */ new Date(), Hi = function(r, t) {
  ft || (ft = t, re = r, La = /* @__PURE__ */ new Date(), Ca(removeEventListener), Ma());
}, Ma = function() {
  if (re >= 0 && re < La - Av) {
    var r = { entryType: "first-input", name: ft.type, target: ft.target, cancelable: ft.cancelable, startTime: ft.timeStamp, processingStart: ft.timeStamp + re };
    je.forEach(function(t) {
      t(r);
    }), je = [];
  }
}, Rv = function(r) {
  if (r.cancelable) {
    var t = (r.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - r.timeStamp;
    r.type == "pointerdown" ? function(e, n) {
      var i = function() {
        Hi(e, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, Jt), removeEventListener("pointercancel", o, Jt);
      };
      addEventListener("pointerup", i, Jt), addEventListener("pointercancel", o, Jt);
    }(t, r) : Hi(t, r);
  }
}, Ca = function(r) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return r(t, Rv, Jt);
  });
}, Gi = [100, 300], Lv = function(r, t) {
  t = t || {}, pe(function() {
    var e, n = En(), i = F("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), e(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = Ft("first-input", a);
    e = $(r, i, Gi, t.reportAllChanges), u && Ke(yn(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Pt(function() {
      var c;
      i = F("FID"), e = $(r, i, Gi, t.reportAllChanges), je = [], re = -1, ft = null, Ca(addEventListener), c = o, je.push(c), Ma();
    });
  });
}, Ia = 0, xr = 1 / 0, Ae = 0, Pv = function(r) {
  r.forEach(function(t) {
    t.interactionId && (xr = Math.min(xr, t.interactionId), Ae = Math.max(Ae, t.interactionId), Ia = Ae ? (Ae - xr) / 7 + 1 : 0);
  });
}, xa = function() {
  return en ? Ia : performance.interactionCount || 0;
}, Nv = function() {
  "interactionCount" in performance || en || (en = Ft("event", Pv, { type: "event", buffered: !0, durationThreshold: 0 }));
}, ji = [200, 500], Da = 0, Vi = function() {
  return xa() - Da;
}, J = [], Dr = {}, Fi = function(r) {
  var t = J[J.length - 1], e = Dr[r.interactionId];
  if (e || J.length < 10 || r.duration > t.latency) {
    if (e) e.entries.push(r), e.latency = Math.max(e.latency, r.duration);
    else {
      var n = { id: r.interactionId, latency: r.duration, entries: [r] };
      Dr[n.id] = n, J.push(n);
    }
    J.sort(function(i, o) {
      return o.latency - i.latency;
    }), J.splice(10).forEach(function(i) {
      delete Dr[i.id];
    });
  }
}, Mv = function(r, t) {
  t = t || {}, pe(function() {
    var e;
    Nv();
    var n, i = F("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && Fi(l), l.entryType === "first-input" && !J.some(function(f) {
          return f.entries.some(function(d) {
            return l.duration === d.duration && l.startTime === d.startTime;
          });
        }) && Fi(l);
      });
      var c, s = (c = Math.min(J.length - 1, Math.floor(Vi() / 50)), J[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = Ft("event", o, { durationThreshold: (e = t.durationThreshold) !== null && e !== void 0 ? e : 40 });
    n = $(r, i, ji, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), Ke(function() {
      o(a.takeRecords()), i.value < 0 && Vi() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Pt(function() {
      J = [], Da = xa(), i = F("INP"), n = $(r, i, ji, t.reportAllChanges);
    }));
  });
}, $i = [2500, 4e3], Ur = {}, Cv = function(r, t) {
  t = t || {}, pe(function() {
    var e, n = En(), i = F("LCP"), o = function(c) {
      var s = c[c.length - 1];
      s && s.startTime < n.firstHiddenTime && (i.value = Math.max(s.startTime - Ye(), 0), i.entries = [s], e());
    }, a = Ft("largest-contentful-paint", o);
    if (a) {
      e = $(r, i, $i, t.reportAllChanges);
      var u = yn(function() {
        Ur[i.id] || (o(a.takeRecords()), a.disconnect(), Ur[i.id] = !0, e(!0));
      });
      ["keydown", "click"].forEach(function(c) {
        addEventListener(c, function() {
          return setTimeout(u, 0);
        }, !0);
      }), Ke(u), Pt(function(c) {
        i = F("LCP"), e = $(r, i, $i, t.reportAllChanges), mn(function() {
          i.value = performance.now() - c.timeStamp, Ur[i.id] = !0, e(!0);
        });
      });
    }
  });
}, Xi = [800, 1800], Iv = function r(t) {
  document.prerendering ? pe(function() {
    return r(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return r(t);
  }, !0) : setTimeout(t, 0);
}, xv = function(r, t) {
  t = t || {};
  var e = F("TTFB"), n = $(r, e, Xi, t.reportAllChanges);
  Iv(function() {
    var i = gn();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      e.value = Math.max(o - Ye(), 0), e.entries = [i], n(!0), Pt(function() {
        e = F("TTFB", 0), (n = $(r, e, Xi, t.reportAllChanges))(!0);
      });
    }
  });
};
const Dv = (r) => (Ov(r), Na(r), Lv(r), Cv(r), xv(r), Mv(r), () => {
}), Ut = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, Uv = (r, t) => {
  const e = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    r({
      relativeTimestamp: o,
      downlink: Ut.downlink,
      downlinkMax: Ut.downlinkMax,
      effectiveType: Ut.effectiveType,
      rtt: Ut.rtt,
      saveData: Ut.saveData,
      type: Ut.type
    });
  };
  e();
  let n;
  return n = setInterval(() => {
    e();
  }, 1e3), () => {
    clearInterval(n);
  };
}, kv = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const r = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: Bv(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = kr(
        r.memory.jsHeapSizeLimit
      ), i = kr(
        r.memory.totalJSHeapSize
      ), o = kr(
        r.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, kr = (r) => r / Math.pow(1e3, 2), Bv = (r) => 1024 * r;
function Hv(r) {
  return "regexValue" in r;
}
function Gv(r) {
  return "matchValue" in r;
}
function jv(r) {
  const t = Math.trunc(r);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class Vv {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = jv) {
    A(this, "regexCache", /* @__PURE__ */ new Map());
    A(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, e, n, i;
    return !!((e = (t = this.config) == null ? void 0 : t.logs) != null && e.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var e, n;
    return t.name === ba ? this.sampleLog((e = this.config) == null ? void 0 : e.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, e) {
    if (!t)
      return !1;
    if (Gv(t))
      return t.matchValue === e;
    if (Hv(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof e == "string")
        return i.test(e);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, e) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(e))
          if (this.matchesValue(n.key, o)) {
            const a = e[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, e) {
    return !(t.name && !this.matchesValue(t.name, e.name) || t.attributes && (!e.attributes || !this.matchesAttributes(
      t.attributes,
      e.attributes
    )));
  }
  matchesEvents(t, e) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of e)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, e) {
    return !(t.name && !this.matchesValue(t.name, e.name) || !this.matchesAttributes(t.attributes, e.attributes) || !this.matchesEvents(t.events, e.events));
  }
  matchesLogConfig(t, e) {
    if (t.severityText) {
      const n = e[wa];
      if (typeof n == "string" && !this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = e[Oa];
      if (typeof n == "string" && !this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, e);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, e) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, e))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [Li]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, e) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, e.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [Li]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const zi = () => {
  const r = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, e) => r,
    setAttributes: (t) => r,
    addEvent: (t, e, n) => r,
    addLinks: (t) => r,
    setStatus: (t) => r,
    recordException: () => {
    },
    addLink: () => r,
    updateName: () => r,
    isRecording: () => !1
  };
  return r;
}, Fv = "exception", $v = function(r, t, e) {
  if (!r)
    return;
  const n = b({}, e);
  typeof t == "string" ? n[rr] = t : t && (t.code ? n[er] = t.code.toString() : t.name && (n[er] = t.name), t.message && (n[rr] = t.message), t.stack && (n[Ka] = t.stack)), n[er] || n[rr] ? r.addEvent(Fv, n) : gs(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
class Xv {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    A(this, "organizationID");
    A(this, "_options");
    A(this, "_integrations", []);
    A(this, "_gauges", /* @__PURE__ */ new Map());
    A(this, "_counters", /* @__PURE__ */ new Map());
    A(this, "_histograms", /* @__PURE__ */ new Map());
    A(this, "_up_down_counters", /* @__PURE__ */ new Map());
    A(this, "sampler", new Vv());
    A(this, "_started", !1);
    A(this, "providers");
    A(this, "graphqlSDK");
    this._options = t, this.organizationID = t.projectId;
  }
  start() {
    return z(this, null, function* () {
      var e, n, i, o, a, u, c, s, l, f, d, h, _, p, g, m;
      if (this._started)
        return;
      this._started = !0, this.providers = dv(
        {
          backendUrl: (n = (e = this._options) == null ? void 0 : e.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (l = this._options) == null ? void 0 : l.tracingOrigins,
          serviceName: (d = (f = this._options) == null ? void 0 : f.serviceName) != null ? d : "browser",
          instrumentations: (_ = (h = this._options) == null ? void 0 : h.otel) == null ? void 0 : _.instrumentations,
          eventNames: (g = (p = this._options) == null ? void 0 : p.otel) == null ? void 0 : g.eventNames,
          getIntegrations: () => this._integrations
        },
        this.sampler
      );
      const t = new Qa(
        (m = this._options.backendUrl) != null ? m : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      this.graphqlSDK = Ja(t, Za()), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return z(this, null, function* () {
      var t, e, n, i;
      this._started && (this._started = !1, yield Promise.all([
        (e = (t = this.providers) == null ? void 0 : t.tracerProvider) == null ? void 0 : e.shutdown(),
        (i = (n = this.providers) == null ? void 0 : n.meterProvider) == null ? void 0 : i.shutdown()
      ]));
    });
  }
  configureSampling() {
    return z(this, null, function* () {
      try {
        const t = yield this.graphqlSDK.GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Zi(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, e, n, i) {
    this.startSpan(ba, (o) => {
      const a = typeof t == "string" ? t : Bt(t), u = i ? Bt(i.map((c) => c.toString())) : void 0;
      if (o == null || o.addEvent("log", b({
        [wa]: e,
        [Oa]: a,
        "code.stacktrace": u
      }, n)), this._options.reportConsoleErrors && e === "error") {
        o == null || o.recordException(new Error(a)), o == null || o.setStatus({
          code: Ie.ERROR,
          message: a
        });
        const c = new Error(a);
        i && (c.stack = u), this.recordError(c);
      }
    });
  }
  _recordErrorMessage(t, e) {
    this.startSpan("highlight.exception", (n) => {
      var i;
      $v(n, (i = t.error) != null ? i : new Error(t.event), {
        [fv]: t.id
      }), n == null || n.setAttributes(b({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, e));
    });
    for (const n of this._integrations)
      n.error(ut(), t);
  }
  recordError(t, e, n, i, o) {
    var s, l, f, d;
    t instanceof Error && t.cause && (n = P(b({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = e ? e + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = Fe(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (l = u[0]) == null ? void 0 : l.lineNumber : 0,
      columnNumber: (f = u[0]) != null && f.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: to()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    const e = Z.getMeter(Oe);
    let n = this._counters.get(t.name);
    n || (n = e.createCounter(t.name), this._counters.set(t.name, n)), n.add(t.value, P(b({}, t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  recordGauge(t) {
    var o, a, u;
    const e = Z.getMeter(Oe);
    let n = this._gauges.get(t.name);
    n || (n = e.createGauge(t.name), this._gauges.set(t.name, n)), n.record(t.value, P(b({}, t.attributes), {
      "highlight.session_id": ut()
    }));
    const i = {
      name: t.name,
      value: t.value,
      category: (o = t.attributes) == null ? void 0 : o.category,
      group: (u = (a = t.attributes) == null ? void 0 : a.group) == null ? void 0 : u.toString(),
      tags: t.attributes ? Object.entries(t.attributes).map(([c, s]) => {
        var l;
        return {
          name: c != null ? c : "",
          value: (l = s == null ? void 0 : s.toString()) != null ? l : ""
        };
      }) : []
    };
    for (const c of this._integrations)
      c.recordGauge(
        ut(),
        i
      );
  }
  recordIncr(t) {
    this.recordCount(P(b({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    const e = Z.getMeter(Oe);
    let n = this._histograms.get(t.name);
    n || (n = e.createHistogram(t.name), this._histograms.set(t.name, n)), n.record(t.value, P(b({}, t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  recordUpDownCounter(t) {
    const e = Z.getMeter(Oe);
    let n = this._up_down_counters.get(t.name);
    n || (n = e.createUpDownCounter(t.name), this._up_down_counters.set(t.name, n)), n.add(t.value, P(b({}, t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  startSpan(t, e, n, i) {
    const o = Pi();
    if (!o) {
      const u = zi();
      return i === void 0 && n === void 0 ? e(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, e)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      e,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      e,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, e, n, i) {
    const o = Pi();
    if (!o) {
      const a = zi();
      return i === void 0 && n === void 0 ? e(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, e) : i === void 0 ? o.startActiveSpan(
      t,
      e,
      n
    ) : o.startActiveSpan(
      t,
      e,
      n,
      i
    );
  }
  register(t, e) {
    this._integrations.push(new ts(t, e));
  }
  getHooks(t) {
    return this._integrations.flatMap((e) => {
      var n, i;
      return (i = (n = e.getHooks) == null ? void 0 : n.call(e, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: e,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: Ct.ViewportHeight,
      value: t,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: Ct.ViewportWidth,
      value: e,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: Ct.ScreenHeight,
      value: n,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: Ct.ScreenWidth,
      value: i,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: Ct.ViewportArea,
      value: t * e,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var e;
    this._options.disableConsoleRecording || Ts(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (e = this._options.consoleMethodsToRecord) != null ? e : [
          ...Wi
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (bv((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: W.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), Tv((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: W.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Ns(
      (n) => {
        var a;
        if (Cs.includes(n.event) || Is.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = Bt(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          P(b({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), Dv((n) => {
      const { name: i, value: o } = n;
      this.recordGauge({
        name: i,
        value: o,
        attributes: {
          group: window.location.href,
          category: W.WebVital
        }
      });
    }), es((n) => {
      this.submitViewportMetrics(n);
    }), Uv((n) => {
      const i = {
        category: W.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(
        ([o, a]) => a && typeof a == "number" && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        })
      );
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = kv();
    t && this.recordGauge({
      name: Ct.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: W.Device,
        group: window.location.href
      }
    });
  }
  recordLog(t, e, n) {
    return this._recordLog(t, e, n);
  }
}
class rg extends rs {
  constructor(e) {
    super(e);
    A(this, "observe");
    A(this, "options");
    this.options = e;
  }
  initialize(e, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!e) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(e, n), this.observe = new Xv(P(b({}, n), {
        projectId: e,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), ms.load(this.observe);
    } catch (i) {
      Zi(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(e, n) {
    var i;
    (i = this.observe) == null || i.register(e, n);
  }
  getHooks(e) {
    var i, o, a, u;
    const n = b(b({
      [fs]: e.sdk.name,
      [ls]: e.sdk.version,
      [cs]: e.clientSideId,
      [us]: "LaunchDarkly"
    }, (i = e.application) != null && i.id ? { [ss]: e.application.id } : {}), (o = e.application) != null && o.version ? {
      [as]: e.application.version
    } : {});
    return this.initialize(
      (u = (a = e.sdkKey) != null ? a : e.mobileKey) != null ? u : e.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, l) => {
          var f, d, h, _, p, g, m, y;
          for (const w of (h = (d = (f = this.observe) == null ? void 0 : f.getHooks) == null ? void 0 : d.call(f, e)) != null ? h : [])
            (_ = w.afterIdentify) == null || _.call(w, c, s, l);
          if (l.status === "completed") {
            const w = P(b({}, An(c.context)), {
              key: (m = (g = (p = this.options) == null ? void 0 : p.contextFriendlyName) == null ? void 0 : g.call(
                p,
                c.context
              )) != null ? m : nr(c.context),
              timeout: c.timeout,
              canonicalKey: nr(c.context),
              [vs]: l.status
            });
            (y = this.observe) == null || y.recordLog("LD.identify", "info", b(b({}, n), w));
          }
          return s;
        },
        afterEvaluation: (c, s, l) => {
          var h, _, p, g, m;
          for (const y of (p = (_ = (h = this.observe) == null ? void 0 : h.getHooks) == null ? void 0 : _.call(h, e)) != null ? p : [])
            (g = y.afterEvaluation) == null || g.call(y, c, s, l);
          const f = b({
            [ps]: c.flagKey,
            [ns]: JSON.stringify(l.value)
          }, l.variationIndex ? {
            [ds]: l.variationIndex
          } : {});
          if (l.reason)
            for (const y in Rn) {
              const w = y, L = l.reason[w];
              L && (f[Rn[w]] = L);
            }
          c.context && (f[hs] = JSON.stringify(An(c.context)), f[_s] = nr(c.context));
          const d = b(b({}, n), f);
          return (m = this.observe) == null || m.startSpan(is, (y) => {
            y && y.addEvent(os, d);
          }), s;
        },
        afterTrack: (c) => {
          var s, l, f, d, h;
          for (const _ of (f = (l = (s = this.observe) == null ? void 0 : s.getHooks) == null ? void 0 : l.call(s, e)) != null ? f : [])
            (d = _.afterTrack) == null || d.call(_, c);
          (h = this.observe) == null || h.recordLog("LD.track", "info", b(P(b({}, n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {}));
        }
      }
    ];
  }
}
export {
  Oe as B,
  Ts as C,
  Fd as D,
  Ns as E,
  tg as F,
  Tv as J,
  Uv as N,
  rg as O,
  bv as P,
  Dv as W,
  Qv as X,
  pn as a,
  Cs as b,
  Is as c,
  Kv as d,
  Ss as e,
  dv as f,
  Vv as g,
  kv as h,
  Z as i,
  Xo as j,
  Pi as k,
  zi as l,
  Zv as m,
  Fe as p,
  to as r,
  eg as s
};
//# sourceMappingURL=observe-BKxWWCLw.js.map
